
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("lU1vD", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7r5Hr = parcelRequire("7r5Hr");


var $dpsRj = parcelRequire("dpsRj");

const $8d7cd7e0bba12695$export$5eb35a4771ec4090 = (head)=>{
    if (!head || !head.cells) return;
    head.cells.forEach((cell)=>{
        if (cell.isSortable && !cell.key) try {
            throw Error("isSortable can't be set to true, if the 'key' prop is missing.");
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    });
};



var $jfLxM = parcelRequire("jfLxM");


var $iHx0I = parcelRequire("iHx0I");










parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $5c26b05e4fb09102$var$captionStyles = null;
const $5c26b05e4fb09102$export$32fbfacc5d962e0c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_2sNsIgWSk4 _0rIjyk2ADO _43nrzTNHnM _1sLQ8qC67X"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)("caption", {
            className: t1,
            children: children
        });
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ children: children })=>/*#__PURE__*/ (0, $8aG6j.jsx)("caption", {
        className: (0, $hekY6.default)([
            "_2sNsIgWSk4 _0rIjyk2ADO _43nrzTNHnM _1sLQ8qC67X"
        ]),
        children: children
    });











parcelRequire("cozmU");




const $e2f07650fad02bf8$var$emptyViewContainerStyles = null;
const $e2f07650fad02bf8$export$381ea436de119582 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children, testId: testId } = props;
    const t0 = testId && `${testId}--empty-view-container`;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_313842IZbP _0adFHsIZbP _1DCdHiIZbP _2XsHFMIZbP _0Of8r2uFDC _1ZnuxbuFDC _1wydGWuFDC _2Zuz6QuFDC _39xV02715P _2fwxA5DIqT"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children || $[2] !== t0) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            "data-testid": t0,
            className: t1,
            children: children
        });
        $[1] = children;
        $[2] = t0;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : (props)=>{
    const { children: children, testId: testId } = props;
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        "data-testid": testId && `${testId}--empty-view-container`,
        className: (0, $hekY6.default)([
            "_313842IZbP _0adFHsIZbP _1DCdHiIZbP _2XsHFMIZbP _0Of8r2uFDC _1ZnuxbuFDC _1wydGWuFDC _2Zuz6QuFDC _39xV02715P _2fwxA5DIqT"
        ]),
        children: children
    });
};











parcelRequire("cozmU");




const $f90c20e8ccf48851$var$fixedHeightStyles = null;
const $f90c20e8ccf48851$export$8f45b9407d4090d7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children, testId: testId } = t0;
    const t1 = testId && `${testId}--empty-view-with-fixed-height`;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            "_0jFU0VB34T"
        ]);
        $[0] = t2;
    } else t2 = $[0];
    let t3;
    if ($[1] !== children || $[2] !== t1) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            "data-testid": t1,
            className: t2,
            children: children
        });
        $[1] = children;
        $[2] = t1;
        $[3] = t3;
    } else t3 = $[3];
    return t3;
} : ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        "data-testid": testId && `${testId}--empty-view-with-fixed-height`,
        className: (0, $hekY6.default)([
            "_0jFU0VB34T"
        ]),
        children: children
    });











parcelRequire("cozmU");




const $2fd7e9f40e2b519d$var$paginationWrapperStyles = null;
const $2fd7e9f40e2b519d$export$3e5e12dc01f20a43 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children, testId: testId } = t0;
    const t1 = testId && `${testId}--pagination--container`;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _37wbyuDIqT"
        ]);
        $[0] = t2;
    } else t2 = $[0];
    let t3;
    if ($[1] !== children || $[2] !== t1) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            "data-testid": t1,
            className: t2,
            children: children
        });
        $[1] = children;
        $[2] = t1;
        $[3] = t3;
    } else t3 = $[3];
    return t3;
} : ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        "data-testid": testId && `${testId}--pagination--container`,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _37wbyuDIqT"
        ]),
        children: children
    });

















const $7f9cc963fb218178$var$fixedSizeTableStyles = null;
const $7f9cc963fb218178$var$tableStyles = null;
const $7f9cc963fb218178$var$bodyBorder = null;
const $7f9cc963fb218178$export$54ec01a60f47d33d = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(20);
    let children;
    let hasDataRow;
    let isFixedSize;
    let isLoading;
    let rest;
    let testId;
    if ($[0] !== t0) {
        ({ isFixedSize: isFixedSize, hasDataRow: hasDataRow, children: children, testId: testId, isLoading: isLoading, ...rest } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = hasDataRow;
        $[3] = isFixedSize;
        $[4] = isLoading;
        $[5] = rest;
        $[6] = testId;
    } else {
        children = $[1];
        hasDataRow = $[2];
        isFixedSize = $[3];
        isLoading = $[4];
        rest = $[5];
        testId = $[6];
    }
    const t1 = isLoading ? "" : undefined;
    let t2;
    if ($[7] !== t1) {
        t2 = {
            inert: t1
        };
        $[7] = t1;
        $[8] = t2;
    } else t2 = $[8];
    let t3;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
            "--local-dynamic-table-hover-bg": "var(--ds-background-neutral-subtle-hovered, #0515240F)",
            "--local-dynamic-table-highlighted-bg": "var(--ds-background-selected, #E9F2FE)",
            "--local-dynamic-table-hover-highlighted-bg": "var(--ds-background-selected-hovered, #CFE1FD)",
            "--local-dynamic-table-row-focus-outline": "var(--ds-border-focused, #4688EC)"
        };
        $[9] = t3;
    } else t3 = $[9];
    const t4 = testId && `${testId}--table`;
    const t5 = isFixedSize && "_3Kbj8ay1CL";
    const t6 = hasDataRow && "_2R4pr31z4g";
    let t7;
    if ($[10] !== t5 || $[11] !== t6) {
        t7 = (0, $hekY6.default)([
            "_39xV02N91d _2i6rxZWTl1 _0Mq23cdnbC _0WKd3G4z3T",
            t5,
            t6
        ]);
        $[10] = t5;
        $[11] = t6;
        $[12] = t7;
    } else t7 = $[12];
    let t8;
    if ($[13] !== children || $[14] !== ref || $[15] !== rest || $[16] !== t2 || $[17] !== t4 || $[18] !== t7) {
        t8 = /*#__PURE__*/ (0, $8aG6j.jsx)("table", {
            ...t2,
            style: t3,
            ref: ref,
            ...rest,
            "data-testid": t4,
            className: t7,
            children: children
        });
        $[13] = children;
        $[14] = ref;
        $[15] = rest;
        $[16] = t2;
        $[17] = t4;
        $[18] = t7;
        $[19] = t8;
    } else t8 = $[19];
    return t8;
} : ({ isFixedSize: isFixedSize, hasDataRow: hasDataRow, children: children, testId: testId, isLoading: isLoading, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)("table" // React and Typescript do not yet support the inert attribute https://github.com/facebook/react/pull/24730
    , {
        inert: isLoading ? '' : undefined,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-hover-bg': "var(--ds-background-neutral-subtle-hovered, #0515240F)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-highlighted-bg': "var(--ds-background-selected, #E9F2FE)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-hover-highlighted-bg': "var(--ds-background-selected-hovered, #CFE1FD)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-row-focus-outline': "var(--ds-border-focused, #4688EC)"
        },
        ref: ref,
        ...rest,
        "data-testid": testId && `${testId}--table`,
        className: (0, $hekY6.default)([
            "_39xV02N91d _2i6rxZWTl1 _0Mq23cdnbC _0WKd3G4z3T",
            isFixedSize && "_3Kbj8ay1CL",
            hasDataRow && "_2R4pr31z4g"
        ]),
        children: children
    });
});















var $6LhkM = parcelRequire("6LhkM");














var $3Cyjf = parcelRequire("3Cyjf");


var $fNX95 = parcelRequire("fNX95");

const $e244a0d606afa77b$var$Row = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(20);
    const { row: row, head: head, testId: testId, isFixedSize: isFixedSize, isHighlighted: isHighlighted } = t0;
    let cells;
    let restRowProps;
    if ($[0] !== row) {
        ({ cells: cells, ...restRowProps } = row);
        $[0] = row;
        $[1] = cells;
        $[2] = restRowProps;
    } else {
        cells = $[1];
        restRowProps = $[2];
    }
    let t1;
    if ($[3] !== isHighlighted) {
        t1 = isHighlighted ? {
            "data-ts--dynamic-table--table-row--highlighted": true
        } : null;
        $[3] = isHighlighted;
        $[4] = t1;
    } else t1 = $[4];
    const t2 = row.testId || testId && `${testId}--row-${restRowProps.key}`;
    let t3;
    if ($[5] !== cells || $[6] !== head || $[7] !== isFixedSize || $[8] !== testId) {
        let t4;
        if ($[10] !== head || $[11] !== isFixedSize || $[12] !== testId) {
            t4 = (cell, cellIndex)=>{
                const { content: content, testId: cellTestId, ...restCellProps } = cell;
                const { shouldTruncate: shouldTruncate, width: width } = (head || {
                    cells: []
                }).cells[cellIndex] || {};
                return /*#__PURE__*/ (0, $cozmU.createElement)((0, $3Cyjf.TableBodyCell), {
                    "data-testid": cellTestId || testId && `${testId}--cell-${cellIndex}`,
                    ...restCellProps,
                    isFixedSize: isFixedSize,
                    key: cellIndex,
                    shouldTruncate: shouldTruncate,
                    width: width
                }, content);
            };
            $[10] = head;
            $[11] = isFixedSize;
            $[12] = testId;
            $[13] = t4;
        } else t4 = $[13];
        t3 = cells.map(t4);
        $[5] = cells;
        $[6] = head;
        $[7] = isFixedSize;
        $[8] = testId;
        $[9] = t3;
    } else t3 = $[9];
    let t4;
    if ($[14] !== isHighlighted || $[15] !== restRowProps || $[16] !== t1 || $[17] !== t2 || $[18] !== t3) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fNX95.TableBodyRow), {
            ...restRowProps,
            isHighlighted: isHighlighted,
            ...t1,
            testId: t2,
            children: t3
        });
        $[14] = isHighlighted;
        $[15] = restRowProps;
        $[16] = t1;
        $[17] = t2;
        $[18] = t3;
        $[19] = t4;
    } else t4 = $[19];
    return t4;
} : ({ row: row, head: head, testId: testId, isFixedSize: isFixedSize, isHighlighted: isHighlighted })=>{
    const { cells: cells, ...restRowProps } = row;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fNX95.TableBodyRow), {
        ...restRowProps,
        isHighlighted: isHighlighted,
        ...isHighlighted ? {
            'data-ts--dynamic-table--table-row--highlighted': true
        } : null,
        testId: row.testId || testId && `${testId}--row-${restRowProps.key}`,
        children: cells.map((cell, cellIndex)=>{
            const { content: content, testId: cellTestId, ...restCellProps } = cell;
            const { shouldTruncate: shouldTruncate, width: width } = (head || {
                cells: []
            }).cells[cellIndex] || {};
            return /*#__PURE__*/ (0, $cozmU.createElement)((0, $3Cyjf.TableBodyCell), {
                "data-testid": cellTestId || testId && `${testId}--cell-${cellIndex}`,
                ...restCellProps,
                isFixedSize: isFixedSize,
                key: cellIndex,
                shouldTruncate: shouldTruncate,
                width: width
            }, content);
        })
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e244a0d606afa77b$export$2e2bcd8739ae039 = $e244a0d606afa77b$var$Row;


// eslint-disable-next-line @repo/internal/react/no-class-components
class $cc2c87abcc03b65c$var$BodyComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    render() {
        const { pageRows: pageRows, head: head, isFixedSize: isFixedSize, highlightedRowIndex: highlightedRowIndex, testId: testId, forwardedRef: forwardedRef } = this.props;
        return /*#__PURE__*/ (0, $8aG6j.jsx)("tbody", {
            "data-testid": testId && `${testId}--body`,
            ref: forwardedRef,
            children: pageRows.map((row, rowIndex)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $e244a0d606afa77b$export$2e2bcd8739ae039), {
                    head: head,
                    isFixedSize: isFixedSize,
                    row: row,
                    isHighlighted: row.isHighlighted || !!highlightedRowIndex && (typeof highlightedRowIndex === 'number' ? highlightedRowIndex === rowIndex : highlightedRowIndex.indexOf(rowIndex) > -1),
                    testId: testId
                }, row.key || rowIndex))
        });
    }
}
const $cc2c87abcc03b65c$var$Body = (0, $6LhkM.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] !== props || $[1] !== ref) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)($cc2c87abcc03b65c$var$BodyComponent, {
            ...props,
            forwardedRef: ref
        });
        $[0] = props;
        $[1] = ref;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props, ref)=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)($cc2c87abcc03b65c$var$BodyComponent, {
        ...props,
        forwardedRef: ref
    });
}));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$cc2c87abcc03b65c$export$2e2bcd8739ae039 = $cc2c87abcc03b65c$var$Body;





class $adc4070934df864d$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true
        };
    }
    render() {
        if (this.state.hasError) // You can render any custom fallback UI
        return this.props.fallback;
        return this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
}









var $lfoFx = parcelRequire("lfoFx");










parcelRequire("cozmU");




const $3c9150da0589227a$var$containerStyles = null;
const $3c9150da0589227a$export$42a852a2b6b56249 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children, testId: testId } = t0;
    const t1 = testId && `${testId}--container`;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            "_1mT5xdRAKS"
        ]);
        $[0] = t2;
    } else t2 = $[0];
    let t3;
    if ($[1] !== children || $[2] !== t1) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            "data-testid": t1,
            className: t2,
            children: children
        });
        $[1] = children;
        $[2] = t1;
        $[3] = t3;
    } else t3 = $[3];
    return t3;
} : ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        "data-testid": testId && `${testId}--container`,
        className: (0, $hekY6.default)([
            "_1mT5xdRAKS"
        ]),
        children: children
    });











parcelRequire("cozmU");




const $843bd93869a044cb$var$CSS_VAR_CONTENTS_OPACITY = '--contents-opacity';
const $843bd93869a044cb$var$contentsContainerStyles = null;
const $843bd93869a044cb$export$67c29eae8ae2137a = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { children: children, contentsOpacity: contentsOpacity, testId: testId } = t0;
    let t1;
    if ($[0] !== contentsOpacity) {
        t1 = {
            [$843bd93869a044cb$var$CSS_VAR_CONTENTS_OPACITY]: contentsOpacity
        };
        $[0] = contentsOpacity;
        $[1] = t1;
    } else t1 = $[1];
    const t2 = t1;
    const t3 = testId && `${testId}--contents--container`;
    let t4;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $hekY6.default)([
            "_1YKVNsLjGI _1pp6NdYbGa"
        ]);
        $[2] = t4;
    } else t4 = $[2];
    let t5;
    if ($[3] !== children || $[4] !== t2 || $[5] !== t3) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            style: t2,
            "data-testid": t3,
            className: t4,
            children: children
        });
        $[3] = children;
        $[4] = t2;
        $[5] = t3;
        $[6] = t5;
    } else t5 = $[6];
    return t5;
} : ({ children: children, contentsOpacity: contentsOpacity, testId: testId })=>/*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        style: {
            [$843bd93869a044cb$var$CSS_VAR_CONTENTS_OPACITY]: contentsOpacity
        },
        "data-testid": testId && `${testId}--contents--container`,
        className: (0, $hekY6.default)([
            "_1YKVNsLjGI _1pp6NdYbGa"
        ]),
        children: children
    });











parcelRequire("cozmU");




const $7b568d22405749aa$var$spinnerContainerStyles = null;
const $7b568d22405749aa$export$a5e06607a5ac6158 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children, testId: testId } = t0;
    const t1 = testId && `${testId}--spinner--container`;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            "_49OCfRdnbC _3iDTPbQ4SZ _1mT5xdWVPG _0hPCNLDIqT _37wbyuDIqT"
        ]);
        $[0] = t2;
    } else t2 = $[0];
    let t3;
    if ($[1] !== children || $[2] !== t1) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            "data-testid": t1,
            className: t2,
            children: children
        });
        $[1] = children;
        $[2] = t1;
        $[3] = t3;
    } else t3 = $[3];
    return t3;
} : ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        "data-testid": testId && `${testId}--spinner--container`,
        className: (0, $hekY6.default)([
            "_49OCfRdnbC _3iDTPbQ4SZ _1mT5xdWVPG _0hPCNLDIqT _37wbyuDIqT"
        ]),
        children: children
    });


class $1f3230d9ef7343db$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, contentsOpacity: contentsOpacity, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $3c9150da0589227a$export$42a852a2b6b56249), {
            testId: testId,
            children: [
                !isLoading ? children : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $843bd93869a044cb$export$67c29eae8ae2137a), {
                    contentsOpacity: contentsOpacity,
                    testId: testId,
                    children: children
                }),
                isLoading && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7b568d22405749aa$export$a5e06607a5ac6158), {
                    testId: testId,
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lfoFx.default), {
                        size: spinnerSize,
                        testId: testId && `${testId}--loadingSpinner`,
                        label: loadingLabel
                    })
                })
            ]
        });
    }
}
$1f3230d9ef7343db$export$2e2bcd8739ae039.defaultProps = {
    isLoading: true,
    spinnerSize: 'large',
    contentsOpacity: 0.22,
    loadingLabel: 'Loading table'
};




















function $894542bbf1d55048$var$_defineProperty(e, r, t) {
    return (r = $894542bbf1d55048$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $894542bbf1d55048$var$_toPropertyKey(t) {
    var i = $894542bbf1d55048$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $894542bbf1d55048$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $894542bbf1d55048$var$containerStyles = null;
const $894542bbf1d55048$var$Container = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(10);
    let children;
    let rest;
    let testId;
    if ($[0] !== props) {
        ({ children: children, testId: testId, ...rest } = props);
        $[0] = props;
        $[1] = children;
        $[2] = rest;
        $[3] = testId;
    } else {
        children = $[1];
        rest = $[2];
        testId = $[3];
    }
    let t0;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $hekY6.default)([
            "_1mT5xdRAKS _0rIjykNHnM"
        ]);
        $[4] = t0;
    } else t0 = $[4];
    let t1;
    if ($[5] !== children || $[6] !== ref || $[7] !== rest || $[8] !== testId) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            ...rest,
            "data-testid": testId,
            ref: ref,
            className: t0,
            children: children
        });
        $[5] = children;
        $[6] = ref;
        $[7] = rest;
        $[8] = testId;
        $[9] = t1;
    } else t1 = $[9];
    return t1;
} : (props, ref)=>{
    const { children: children, testId: testId, ...rest } = props;
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        ...rest,
        "data-testid": testId,
        ref: ref,
        className: (0, $hekY6.default)([
            "_1mT5xdRAKS _0rIjykNHnM"
        ]),
        children: children
    });
});
const $894542bbf1d55048$var$spinnerBackdropStyles = null;
const $894542bbf1d55048$var$SpinnerBackdrop = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children, testId: testId } = t0;
    const t1 = testId && `${testId}--spinner-backdrop`;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            "_49OCfRdnbC _3iDTPbQ4SZ _1mT5xdWVPG _0hPCNLDIqT _37wbyuDIqT _1pp6NdYbGa"
        ]);
        $[0] = t2;
    } else t2 = $[0];
    let t3;
    if ($[1] !== children || $[2] !== t1) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            "data-testid": t1,
            className: t2,
            children: children
        });
        $[1] = children;
        $[2] = t1;
        $[3] = t3;
    } else t3 = $[3];
    return t3;
} : ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        "data-testid": testId && `${testId}--spinner-backdrop`,
        className: (0, $hekY6.default)([
            "_49OCfRdnbC _3iDTPbQ4SZ _1mT5xdWVPG _0hPCNLDIqT _37wbyuDIqT _1pp6NdYbGa"
        ]),
        children: children
    });
const $894542bbf1d55048$var$spinnerContainerStyles = null;
const $894542bbf1d55048$var$SpinnerContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_1mT5xdRAKS _2I62gzdnbC"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children || $[2] !== ref) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            ref: ref,
            className: t1,
            children: children
        });
        $[1] = children;
        $[2] = ref;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : ({ children: children }, ref)=>/*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        ref: ref,
        className: (0, $hekY6.default)([
            "_1mT5xdRAKS _2I62gzdnbC"
        ]),
        children: children
    }));
class $894542bbf1d55048$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    attachListeners() {
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.handleResize);
    }
    detachListeners() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize);
    }
    updateSpinnerPosition() {
        const viewportHeight = window.innerHeight;
        const targetNode = this.getTargetNode();
        const spinnerNode = this.spinnerRef?.current;
        if (!targetNode || typeof targetNode.getBoundingClientRect !== 'function' || !spinnerNode) return;
        const targetRect = targetNode.getBoundingClientRect();
        const spinnerRect = spinnerNode.getBoundingClientRect();
        const spinnerHeight = spinnerRect.height;
        const isInViewport = this.isVerticallyVisible(targetRect, viewportHeight);
        const { top: top, bottom: bottom, height: height } = targetRect;
        if (isInViewport) {
            // The spinner may follow the element only if there is enough space:
            // Let's say the element can fit at least three spinners (vertically)
            const canFollow = height >= spinnerHeight * 3;
            if (canFollow && !this.isFullyVerticallyVisible(targetRect, viewportHeight)) {
                if (top >= 0) {
                    // Only the head of the element is visible
                    const viewportSpaceTakenByElement = viewportHeight - top;
                    const diff = viewportSpaceTakenByElement / 2 + top - spinnerHeight / 2;
                    const y = viewportSpaceTakenByElement < spinnerHeight * 3 ? top + spinnerHeight : diff;
                    this.translateSpinner(spinnerNode, y, true);
                } else if (top < 0 && bottom > viewportHeight) {
                    // The element takes all viewport, nor its head nor tail are visible
                    const y = viewportHeight / 2 - spinnerHeight / 2;
                    this.translateSpinner(spinnerNode, y, true);
                } else {
                    // Only the tail of the element is visible
                    const diff = bottom / 2 - spinnerHeight / 2;
                    const y = diff < spinnerHeight ? diff - (spinnerHeight - diff) : diff;
                    this.translateSpinner(spinnerNode, y, true);
                }
                return;
            }
        } else {
            // If both the element and the spinner are off screen - quit
            if (!this.isVerticallyVisible(spinnerRect, viewportHeight)) return;
        } // Three options here:
        // 1) the element is fully visible
        // 2) the element is too small for the spinner to follow
        // 3) the spinner might still be visible while the element isn't
        const containerNode = this.containerRef?.current;
        if (containerNode && typeof containerNode.getBoundingClientRect === 'function') {
            const thisTop = containerNode.getBoundingClientRect().top;
            const y = (top - thisTop) / 2;
            this.translateSpinner(spinnerNode, y, false);
        }
    }
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, $8aG6j.jsxs)($894542bbf1d55048$var$Container, {
            testId: testId && `${testId}--loading--container--advanced`,
            ref: this.containerRef,
            children: [
                children,
                isLoading && /*#__PURE__*/ (0, $8aG6j.jsx)($894542bbf1d55048$var$SpinnerBackdrop, {
                    testId: testId,
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)($894542bbf1d55048$var$SpinnerContainer, {
                        ref: this.spinnerRef,
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lfoFx.default), {
                            size: spinnerSize,
                            testId: testId && `${testId}--loadingSpinner`,
                            label: loadingLabel
                        })
                    })
                })
            ]
        });
    }
    constructor(...args){
        super(...args);
        $894542bbf1d55048$var$_defineProperty(this, "spinnerRef", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createRef());
        $894542bbf1d55048$var$_defineProperty(this, "containerRef", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createRef());
        $894542bbf1d55048$var$_defineProperty(this, "componentDidMount", ()=>{
            if (this.props.isLoading && this.hasTargetNode()) {
                this.attachListeners();
                this.updateTargetAppearance();
                this.updateSpinnerPosition();
            }
        });
        $894542bbf1d55048$var$_defineProperty(this, "UNSAFE_componentWillReceiveProps", (nextProps)=>{
            if (!nextProps.isLoading || !this.hasTargetNode(nextProps)) this.detachListeners();
            else if (!this.props.isLoading) this.attachListeners();
        });
        $894542bbf1d55048$var$_defineProperty(this, "componentDidUpdate", ()=>{
            if (this.hasTargetNode()) {
                this.updateTargetAppearance();
                if (this.props.isLoading) this.updateSpinnerPosition();
            }
        });
        $894542bbf1d55048$var$_defineProperty(this, "componentWillUnmount", ()=>{
            this.detachListeners();
        });
        $894542bbf1d55048$var$_defineProperty(this, "getTargetNode", (nextProps = this.props)=>{
            const { targetRef: targetRef } = nextProps;
            const target = targetRef?.();
            return target || this.containerRef.current;
        });
        $894542bbf1d55048$var$_defineProperty(this, "hasTargetNode", (nextProps)=>!!this.getTargetNode(nextProps));
        $894542bbf1d55048$var$_defineProperty(this, "isVerticallyVisible", (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            if (bottom <= 0) return false;
            return top < viewportHeight;
        });
        $894542bbf1d55048$var$_defineProperty(this, "isFullyVerticallyVisible", (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            return top >= 0 && bottom <= viewportHeight;
        });
        $894542bbf1d55048$var$_defineProperty(this, "handleResize", ()=>{
            this.updateSpinnerPosition();
        });
        $894542bbf1d55048$var$_defineProperty(this, "handleScroll", ()=>{
            this.updateSpinnerPosition();
        });
        $894542bbf1d55048$var$_defineProperty(this, "translateSpinner", (spinnerNode, transformY, isFixed)=>{
            spinnerNode.style.position = isFixed ? 'fixed' : '';
            spinnerNode.style.transform = transformY !== 0 ? `translate3d(0, ${transformY}px, 0)` : '';
        });
        $894542bbf1d55048$var$_defineProperty(this, "updateTargetAppearance", ()=>{
            const targetNode = this.getTargetNode();
            const { isLoading: isLoading, contentsOpacity: contentsOpacity } = this.props;
            if (targetNode && targetNode.style && typeof targetNode.style === 'object') {
                targetNode.style.pointerEvents = isLoading ? 'none' : '';
                targetNode.style.opacity = isLoading ? contentsOpacity.toString() : '';
            }
        });
    }
}
$894542bbf1d55048$var$_defineProperty($894542bbf1d55048$export$2e2bcd8739ae039, "defaultProps", {
    isLoading: true,
    spinnerSize: 'large',
    contentsOpacity: "var(--ds-opacity-loading, 0.2)",
    loadingLabel: 'Loading table'
});









var $4kJeN = parcelRequire("4kJeN");

class $057a9e1bf87f03b7$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    render() {
        const { total: total, value: value = 1, i18n: i18n, testId: testId, isDisabled: isDisabled } = this.props;
        const pages = [
            ...Array(total)
        ].map((_, index)=>index + 1);
        // Pagination accepts array now thus selectedIndex starts with 0
        // So, we are substracting value by one thus not breaking dynamic table
        const selectedIndex = value - 1;
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4kJeN.default), {
            selectedIndex: selectedIndex,
            isDisabled: isDisabled,
            label: i18n?.label,
            nextLabel: i18n?.next,
            previousLabel: i18n?.prev,
            pageLabel: i18n?.pageLabel,
            onChange: this.onChange,
            pages: pages,
            testId: testId && `${testId}--pagination`
        });
    }
    constructor(...args){
        super(...args);
        this.onChange = (_event, newValue, analyticsEvent)=>{
            this.props.onChange(newValue, analyticsEvent);
        };
    }
}




















parcelRequire("cozmU");




const $43f63a491f547623$var$rankingStyles = null;
const $43f63a491f547623$var$headStyles = null;
const $43f63a491f547623$export$e93312b7773dfcac = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    let isRanking;
    let props;
    let testId;
    if ($[0] !== t0) {
        ({ isRanking: isRanking, testId: testId, ...props } = t0);
        $[0] = t0;
        $[1] = isRanking;
        $[2] = props;
        $[3] = testId;
    } else {
        isRanking = $[1];
        props = $[2];
        testId = $[3];
    }
    const t1 = isRanking && "_3iDTPbvLZJ";
    let t2;
    if ($[4] !== t1) {
        t2 = (0, $hekY6.default)([
            "_2R4pr3YbGa",
            t1
        ]);
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== props || $[7] !== t2 || $[8] !== testId) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)("thead", {
            "data-testid": testId,
            ...props,
            className: t2
        });
        $[6] = props;
        $[7] = t2;
        $[8] = testId;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
} : ({ isRanking: isRanking, testId: testId, ...props })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)("thead", {
        "data-testid": testId,
        ...props,
        className: (0, $hekY6.default)([
            "_2R4pr3YbGa",
            isRanking && "_3iDTPbvLZJ"
        ])
    });
};









var $f3XUw = parcelRequire("f3XUw");


var $igC1g = parcelRequire("igC1g");

















var $fS8Zl = parcelRequire("fS8Zl");


var $f6cdQ = parcelRequire("f6cdQ");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $hBYtq = parcelRequire("hBYtq");


var $lpNn5 = parcelRequire("lpNn5");

















var $aKm7d = parcelRequire("aKm7d");

const $198075616c813fb7$var$CSS_VAR_TEXT_COLOR = '--local-dynamic-table-text-color';
const $198075616c813fb7$var$overflowTruncateStyles = null;
const $198075616c813fb7$var$truncationWidthStyles = null;
const $198075616c813fb7$var$fixedSizeTruncateStyles = null;
const $198075616c813fb7$var$cellStyles = null;
const $198075616c813fb7$var$headCellBaseStyles = null;
const $198075616c813fb7$export$4e8024263ace498b = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(29);
    let children;
    let isFixedSize;
    let rest;
    let shouldTruncate;
    let sortOrder;
    let style;
    let testId;
    let width;
    if ($[0] !== t0) {
        const { width: t1, children: t2, isSortable: isSortable, sortOrder: t3, isFixedSize: t4, shouldTruncate: t5, onClick: onClick, style: t6, testId: t7, ...t8 } = t0;
        width = t1;
        children = t2;
        sortOrder = t3;
        isFixedSize = t4;
        shouldTruncate = t5;
        style = t6;
        testId = t7;
        rest = t8;
        $[0] = t0;
        $[1] = children;
        $[2] = isFixedSize;
        $[3] = rest;
        $[4] = shouldTruncate;
        $[5] = sortOrder;
        $[6] = style;
        $[7] = testId;
        $[8] = width;
    } else {
        children = $[1];
        isFixedSize = $[2];
        rest = $[3];
        shouldTruncate = $[4];
        sortOrder = $[5];
        style = $[6];
        testId = $[7];
        width = $[8];
    }
    let t1;
    if ($[9] !== width) {
        t1 = width && (0, $aKm7d.getTruncationStyleVars)({
            width: width
        });
        $[9] = width;
        $[10] = t1;
    } else t1 = $[10];
    let t2;
    if ($[11] !== style || $[12] !== t1) {
        t2 = {
            ...style,
            ...t1,
            [$198075616c813fb7$var$CSS_VAR_TEXT_COLOR]: "var(--ds-text-subtlest, #6B6E76)"
        };
        $[11] = style;
        $[12] = t1;
        $[13] = t2;
    } else t2 = $[13];
    const mergedStyles = t2;
    const isASC = sortOrder === "ASC";
    const isDESC = sortOrder === "DESC";
    let t3;
    if ($[14] !== isASC || $[15] !== isDESC) {
        t3 = ()=>{
            if (isASC) return "ascending";
            else {
                if (isDESC) return "descending";
            }
        };
        $[14] = isASC;
        $[15] = isDESC;
        $[16] = t3;
    } else t3 = $[16];
    const getFormattedSortOrder = t3;
    const Component = children ? "th" : "td";
    const t4 = getFormattedSortOrder();
    const t5 = isFixedSize && shouldTruncate && "_39HuIbz8Lp _1ANEUSLRg7";
    const t6 = isFixedSize && "_4bt5LAnQyn _2WAcuGnQyn";
    let t7;
    if ($[17] !== t5 || $[18] !== t6) {
        t7 = (0, $hekY6.default)([
            "_029LLIYbGa _18otpjYbGa _0xmtko1Y8M _46hvQm1Y8M _03SyCP2ADO _0LQT5E2ADO _2fwxA5ecOK _4efXyCPgdg _22fNSnPgdg",
            "_2sNsIg7NXe _2R4pr31z4g _1v3aPqYbGa _1mT5xdRAKS _1UtDYzZpcK _1kk5Tkmb2E _2fwxA5ecOK _1RrJLit2nV _4EiLyUfNHp",
            "_39xV02SBlE",
            t5,
            t6
        ]);
        $[17] = t5;
        $[18] = t6;
        $[19] = t7;
    } else t7 = $[19];
    let t8;
    if ($[20] !== Component || $[21] !== children || $[22] !== mergedStyles || $[23] !== ref || $[24] !== rest || $[25] !== t4 || $[26] !== t7 || $[27] !== testId) {
        t8 = /*#__PURE__*/ (0, $8aG6j.jsx)(Component, {
            "aria-sort": t4,
            style: mergedStyles,
            onClick: undefined,
            ref: ref,
            "data-testid": testId,
            ...rest,
            className: t7,
            children: children
        });
        $[20] = Component;
        $[21] = children;
        $[22] = mergedStyles;
        $[23] = ref;
        $[24] = rest;
        $[25] = t4;
        $[26] = t7;
        $[27] = testId;
        $[28] = t8;
    } else t8 = $[28];
    return t8;
} : ({ width: width, children: children, isSortable: isSortable, sortOrder: sortOrder, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, onClick: onClick, style: style, testId: testId, ...rest }, ref)=>{
    const mergedStyles = {
        ...style,
        ...width && (0, $aKm7d.getTruncationStyleVars)({
            width: width
        }),
        [$198075616c813fb7$var$CSS_VAR_TEXT_COLOR]: "var(--ds-text-subtlest, #6B6E76)"
    };
    const isASC = sortOrder === 'ASC';
    const isDESC = sortOrder === 'DESC';
    const getFormattedSortOrder = ()=>{
        if (isASC) return 'ascending';
        else if (isDESC) return 'descending';
        return;
    }; // If there is no content in the cell, it should be rendered as an empty `td`, not a `th`.
    // https://dequeuniversity.com/rules/axe/4.7/empty-table-header
    const Component = children ? 'th' : 'td';
    return /*#__PURE__*/ (0, $8aG6j.jsx)(Component, {
        "aria-sort": getFormattedSortOrder(),
        style: mergedStyles,
        onClick: undefined,
        ref: ref,
        "data-testid": testId,
        ...rest,
        className: (0, $hekY6.default)([
            "_029LLIYbGa _18otpjYbGa _0xmtko1Y8M _46hvQm1Y8M _03SyCP2ADO _0LQT5E2ADO _2fwxA5ecOK _4efXyCPgdg _22fNSnPgdg",
            "_2sNsIg7NXe _2R4pr31z4g _1v3aPqYbGa _1mT5xdRAKS _1UtDYzZpcK _1kk5Tkmb2E _2fwxA5ecOK _1RrJLit2nV _4EiLyUfNHp",
            "_39xV02SBlE",
            isFixedSize && shouldTruncate && "_39HuIbz8Lp _1ANEUSLRg7",
            isFixedSize && "_4bt5LAnQyn _2WAcuGnQyn"
        ]),
        children: children
    });
});


const $a8e3c673927cc478$var$styles = {
    buttonWrapper: "_3iDTPbQ4SZ _0KLXrujOvk _0hPCNLDIqT _0Of8r2Pgdg _1ZnuxbPgdg _1wydGWPgdg _2Zuz6QPgdg _0ReiIH7zJH",
    truncateButtonWrapper: "_3iDTPbQ4SZ _0KLXrujOvk _0hPCNLDIqT _0Of8r2Pgdg _1ZnuxbPgdg _1wydGWPgdg _2Zuz6QPgdg _4ouGXIdnbC _1EqgXlN91d _0ReiIH7zJH",
    sortIconHiddenWrapper: "_3iDTPbQ4SZ _1YKVNsdnbC _0KLXrujOvk _0Of8r21Y8M _1Znuxb1Y8M _1wydGW1Y8M _2Zuz6Q1Y8M _3vJpeh7dHp",
    sortIconVisibleWrapper: "_3iDTPbQ4SZ _1YKVNs7dHp _0KLXrujOvk _0Of8r21Y8M _1Znuxb1Y8M _1wydGW1Y8M _2Zuz6Q1Y8M",
    hideIconHeaderWrapper: "_1YKVNsdnbC _2XsHFMQRM5",
    visibleHeaderWrapper: "_1YKVNs7dHp _1Znuxb1Y8M",
    truncateHeaderWrapper: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _1YKVNs7dHp _1Znuxb1Y8M _4ouGXIdnbC",
    truncateHiddenIconHeaderWrapper: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _1YKVNsdnbC _2XsHFMQRM5 _4ouGXIdnbC",
    truncateTooltipWrapper: "_4ouGXIdnbC _1EqgXlN91d"
};
const $a8e3c673927cc478$var$headCellStyles = {
    headCellContainer: "_3iDTPbQ4SZ _0hPCNLDIqT",
    text: "_2sNsIg7NXe _1UtDYzZpcK _1kk5Tkmb2E",
    truncateText: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4bt5LAnQyn _2WAcuGnQyn _3iDTPbvLZJ _4ouGXIdnbC _39HuIbz8Lp _1ANEUSLRg7"
};
const $a8e3c673927cc478$var$TableHeadCell = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(45);
    let activeSortButtonId;
    let content;
    let headCellId;
    let inlineStyles;
    let innerRef;
    let isFixedSize;
    let isIconOnlyHeader;
    let isSortable;
    let onClick;
    let rest;
    let shouldTruncate;
    let sortOrder;
    let t1;
    let t2;
    let t3;
    let testId;
    if ($[0] !== t0) {
        const { content: t4, inlineStyles: t5, testId: t6, isRanking: isRanking, innerRef: t7, isSortable: t8, sortOrder: t9, onClick: t10, headCellId: t11, activeSortButtonId: t12, ascendingSortTooltip: t13, descendingSortTooltip: t14, buttonAriaRoleDescription: t15, isIconOnlyHeader: t16, isFixedSize: t17, shouldTruncate: t18, ...t19 } = t0;
        content = t4;
        inlineStyles = t5;
        testId = t6;
        innerRef = t7;
        isSortable = t8;
        sortOrder = t9;
        onClick = t10;
        headCellId = t11;
        activeSortButtonId = t12;
        t1 = t13;
        t2 = t14;
        t3 = t15;
        isIconOnlyHeader = t16;
        isFixedSize = t17;
        shouldTruncate = t18;
        rest = t19;
        $[0] = t0;
        $[1] = activeSortButtonId;
        $[2] = content;
        $[3] = headCellId;
        $[4] = inlineStyles;
        $[5] = innerRef;
        $[6] = isFixedSize;
        $[7] = isIconOnlyHeader;
        $[8] = isSortable;
        $[9] = onClick;
        $[10] = rest;
        $[11] = shouldTruncate;
        $[12] = sortOrder;
        $[13] = t1;
        $[14] = t2;
        $[15] = t3;
        $[16] = testId;
    } else {
        activeSortButtonId = $[1];
        content = $[2];
        headCellId = $[3];
        inlineStyles = $[4];
        innerRef = $[5];
        isFixedSize = $[6];
        isIconOnlyHeader = $[7];
        isSortable = $[8];
        onClick = $[9];
        rest = $[10];
        shouldTruncate = $[11];
        sortOrder = $[12];
        t1 = $[13];
        t2 = $[14];
        t3 = $[15];
        testId = $[16];
    }
    const ascendingSortTooltip = t1 === undefined ? "Sort ascending" : t1;
    const descendingSortTooltip = t2 === undefined ? "Sort descending" : t2;
    const buttonAriaRoleDescription = t3 === undefined ? "Sort button" : t3;
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    const [isFocused, setIsFocused] = (0, $cozmU.useState)(false);
    const isActive = headCellId === activeSortButtonId || sortOrder !== undefined;
    const isSortIconVisible = isHovered || isActive || isFocused;
    const isVisibleIconOnlyHeader = isSortIconVisible && isIconOnlyHeader;
    const shouldRenderSortIcon = !isIconOnlyHeader || isSortIconVisible || isIconOnlyHeader && !isFocused;
    let t4;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>{
            setIsFocused?.(true);
        };
        $[17] = t4;
    } else t4 = $[17];
    const handleFocus = t4;
    let t5;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = ()=>{
            setIsFocused?.(false);
        };
        $[18] = t5;
    } else t5 = $[18];
    const handleBlur = t5;
    let t6;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = ()=>{
            setIsHovered(true);
        };
        $[19] = t6;
    } else t6 = $[19];
    const handleMouseEnter = t6;
    let t7;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = ()=>{
            setIsHovered(false);
        };
        $[20] = t7;
    } else t7 = $[20];
    const handleMouseLeave = t7;
    const t8 = sortOrder === "ASC" ? ascendingSortTooltip : descendingSortTooltip;
    let t9;
    if ($[21] !== buttonAriaRoleDescription || $[22] !== content || $[23] !== isFixedSize || $[24] !== isSortIconVisible || $[25] !== isVisibleIconOnlyHeader || $[26] !== onClick || $[27] !== shouldRenderSortIcon || $[28] !== shouldTruncate || $[29] !== sortOrder || $[30] !== testId) {
        t9 = (tooltipProps)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                role: "presentation",
                xcss: isFixedSize && shouldTruncate ? $a8e3c673927cc478$var$styles.truncateTooltipWrapper : undefined,
                children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $hBYtq.Pressable), {
                    ...tooltipProps,
                    onClick: onClick,
                    xcss: isFixedSize && shouldTruncate ? $a8e3c673927cc478$var$styles.truncateButtonWrapper : $a8e3c673927cc478$var$styles.buttonWrapper,
                    "aria-roledescription": buttonAriaRoleDescription,
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4ez2K.Flex), {
                            xcss: isFixedSize && shouldTruncate ? isVisibleIconOnlyHeader ? $a8e3c673927cc478$var$styles.truncateHiddenIconHeaderWrapper : $a8e3c673927cc478$var$styles.truncateHeaderWrapper : isVisibleIconOnlyHeader ? $a8e3c673927cc478$var$styles.hideIconHeaderWrapper : $a8e3c673927cc478$var$styles.visibleHeaderWrapper,
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                                className: (0, $hekY6.default)([
                                    $a8e3c673927cc478$var$headCellStyles.text,
                                    isFixedSize && shouldTruncate && $a8e3c673927cc478$var$headCellStyles.truncateText
                                ]),
                                children: content
                            })
                        }),
                        shouldRenderSortIcon && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4ez2K.Flex), {
                            xcss: isSortIconVisible ? $a8e3c673927cc478$var$styles.sortIconVisibleWrapper : $a8e3c673927cc478$var$styles.sortIconHiddenWrapper,
                            children: sortOrder === "ASC" ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f6cdQ))), {
                                label: "",
                                color: "var(--ds-text-subtle, #505258)",
                                testId: testId && `${testId}--up--icon`
                            }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fS8Zl))), {
                                label: "",
                                color: "var(--ds-text-subtle, #505258)",
                                testId: testId && `${testId}--down--icon`
                            })
                        })
                    ]
                })
            });
        $[21] = buttonAriaRoleDescription;
        $[22] = content;
        $[23] = isFixedSize;
        $[24] = isSortIconVisible;
        $[25] = isVisibleIconOnlyHeader;
        $[26] = onClick;
        $[27] = shouldRenderSortIcon;
        $[28] = shouldTruncate;
        $[29] = sortOrder;
        $[30] = testId;
        $[31] = t9;
    } else t9 = $[31];
    let t10;
    if ($[32] !== t8 || $[33] !== t9) {
        t10 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $a8e3c673927cc478$var$headCellStyles.headCellContainer,
            onMouseEnter: handleMouseEnter,
            onMouseLeave: handleMouseLeave,
            onFocus: handleFocus,
            onBlur: handleBlur,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
                content: t8,
                children: t9
            })
        });
        $[32] = t8;
        $[33] = t9;
        $[34] = t10;
    } else t10 = $[34];
    const visuallyRefreshedButton = t10;
    const t11 = testId && `${testId}--head--cell`;
    const t12 = typeof innerRef !== "string" ? innerRef : null;
    const t13 = isSortable ? visuallyRefreshedButton : content;
    let t14;
    if ($[35] !== inlineStyles || $[36] !== isFixedSize || $[37] !== isSortable || $[38] !== rest || $[39] !== shouldTruncate || $[40] !== sortOrder || $[41] !== t11 || $[42] !== t12 || $[43] !== t13) {
        t14 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $198075616c813fb7$export$4e8024263ace498b), {
            style: inlineStyles,
            testId: t11,
            ref: t12,
            ...rest,
            isFixedSize: isFixedSize,
            isSortable: isSortable,
            sortOrder: sortOrder,
            shouldTruncate: shouldTruncate,
            children: t13
        });
        $[35] = inlineStyles;
        $[36] = isFixedSize;
        $[37] = isSortable;
        $[38] = rest;
        $[39] = shouldTruncate;
        $[40] = sortOrder;
        $[41] = t11;
        $[42] = t12;
        $[43] = t13;
        $[44] = t14;
    } else t14 = $[44];
    return t14;
} : ({ content: content, inlineStyles: inlineStyles, testId: testId, isRanking: isRanking, innerRef: innerRef, isSortable: isSortable, sortOrder: sortOrder, onClick: onClick, headCellId: headCellId, activeSortButtonId: activeSortButtonId, ascendingSortTooltip: ascendingSortTooltip = 'Sort ascending', descendingSortTooltip: descendingSortTooltip = 'Sort descending', buttonAriaRoleDescription: buttonAriaRoleDescription = 'Sort button', isIconOnlyHeader: isIconOnlyHeader, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, ...rest })=>{
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    const [isFocused, setIsFocused] = (0, $cozmU.useState)(false);
    const isActive = headCellId === activeSortButtonId || sortOrder !== undefined;
    const isSortIconVisible = isHovered || isActive || isFocused;
    const isVisibleIconOnlyHeader = isSortIconVisible && isIconOnlyHeader;
    const shouldRenderSortIcon = !isIconOnlyHeader || isSortIconVisible || isIconOnlyHeader && !isFocused;
    const handleFocus = (0, $cozmU.useCallback)(()=>{
        setIsFocused?.(true);
    }, [
        setIsFocused
    ]);
    const handleBlur = (0, $cozmU.useCallback)(()=>{
        setIsFocused?.(false);
    }, [
        setIsFocused
    ]);
    const handleMouseEnter = (0, $cozmU.useCallback)(()=>{
        setIsHovered(true);
    }, [
        setIsHovered
    ]);
    const handleMouseLeave = (0, $cozmU.useCallback)(()=>{
        setIsHovered(false);
    }, [
        setIsHovered
    ]);
    const visuallyRefreshedButton = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $a8e3c673927cc478$var$headCellStyles.headCellContainer,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleFocus,
        onBlur: handleBlur,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
            content: sortOrder === 'ASC' ? ascendingSortTooltip : descendingSortTooltip,
            children: (tooltipProps)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                    role: "presentation",
                    xcss: isFixedSize && shouldTruncate ? $a8e3c673927cc478$var$styles.truncateTooltipWrapper : undefined,
                    children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $hBYtq.Pressable), {
                        ...tooltipProps,
                        onClick: onClick,
                        xcss: isFixedSize && shouldTruncate ? $a8e3c673927cc478$var$styles.truncateButtonWrapper : $a8e3c673927cc478$var$styles.buttonWrapper,
                        "aria-roledescription": buttonAriaRoleDescription,
                        children: [
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4ez2K.Flex), {
                                xcss: isFixedSize && shouldTruncate ? isVisibleIconOnlyHeader ? $a8e3c673927cc478$var$styles.truncateHiddenIconHeaderWrapper : $a8e3c673927cc478$var$styles.truncateHeaderWrapper : isVisibleIconOnlyHeader ? $a8e3c673927cc478$var$styles.hideIconHeaderWrapper : $a8e3c673927cc478$var$styles.visibleHeaderWrapper,
                                children: /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                                    className: (0, $hekY6.default)([
                                        $a8e3c673927cc478$var$headCellStyles.text,
                                        isFixedSize && shouldTruncate && $a8e3c673927cc478$var$headCellStyles.truncateText
                                    ]),
                                    children: content
                                })
                            }),
                            shouldRenderSortIcon && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4ez2K.Flex), {
                                xcss: isSortIconVisible ? $a8e3c673927cc478$var$styles.sortIconVisibleWrapper : $a8e3c673927cc478$var$styles.sortIconHiddenWrapper,
                                children: sortOrder === 'ASC' ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f6cdQ))), {
                                    label: "",
                                    color: "var(--ds-text-subtle, #505258)",
                                    testId: testId && `${testId}--up--icon`
                                }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fS8Zl))), {
                                    label: "",
                                    color: "var(--ds-text-subtle, #505258)",
                                    testId: testId && `${testId}--down--icon`
                                })
                            })
                        ]
                    })
                })
        })
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $198075616c813fb7$export$4e8024263ace498b // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    ), {
        style: inlineStyles,
        testId: testId && `${testId}--head--cell`,
        ref: typeof innerRef !== 'string' ? innerRef : null,
        ...rest,
        isFixedSize: isFixedSize,
        isSortable: isSortable,
        sortOrder: sortOrder,
        shouldTruncate: shouldTruncate,
        children: isSortable ? visuallyRefreshedButton : content
    });
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $a8e3c673927cc478$export$2e2bcd8739ae039 = $a8e3c673927cc478$var$TableHeadCell;


// eslint-disable-next-line @repo/internal/react/no-class-components
class $53506f791efc14b8$var$RankableTableHeadCellComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    render() {
        const { isRanking: isRanking, refHeight: refHeight, refWidth: refWidth, ...restProps } = this.props;
        const inlineStyles = (0, $igC1g.inlineStylesIfRanking)(isRanking, refWidth);
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a8e3c673927cc478$export$2e2bcd8739ae039), {
            inlineStyles: inlineStyles,
            ...restProps
        });
    }
}
const $53506f791efc14b8$var$RankableTableHeadCell = (0, $f3XUw.default)($53506f791efc14b8$var$RankableTableHeadCellComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$53506f791efc14b8$export$2e2bcd8739ae039 = $53506f791efc14b8$var$RankableTableHeadCell;



// eslint-disable-next-line @repo/internal/react/no-class-components
class $5be55afeb6489ab2$var$TableHead extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    UNSAFE_componentWillMount() {
        (0, $iHx0I.validateSortKey)(this.props.sortKey, this.props.head);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.sortKey !== nextProps.sortKey || this.props.head !== nextProps.head) (0, $iHx0I.validateSortKey)(nextProps.sortKey, nextProps.head);
    }
    render() {
        const { head: head, sortKey: sortKey, sortOrder: sortOrder, isFixedSize: isFixedSize, onSort: onSort, isRanking: isRanking, isRankable: isRankable, testId: testId } = this.props;
        const { activeSortButtonId: activeSortButtonId } = this.state;
        if (!head) return null;
        const HeadCellComponent = isRankable ? (0, $53506f791efc14b8$export$2e2bcd8739ae039) : (0, $a8e3c673927cc478$export$2e2bcd8739ae039);
        // TODO: Remove `rest` props and use only what is explicitly in the API.
        // Some tests use this to pass in onClick and other stuff within the `head`
        // variable here, but considering it's not in the API, it should probably
        // be removed.
        const { cells: cells, ...rest } = head;
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $43f63a491f547623$export$e93312b7773dfcac), {
            ...rest,
            isRanking: isRanking,
            testId: testId && `${testId}--head`,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)("tr", {
                children: cells.map((cell, index)=>{
                    const { ascendingSortTooltip: ascendingSortTooltip, buttonAriaRoleDescription: buttonAriaRoleDescription, colSpan: colSpan, content: content, descendingSortTooltip: descendingSortTooltip, isIconOnlyHeader: isIconOnlyHeader, isSortable: isSortable, key: key, shouldTruncate: shouldTruncate, testId: cellTestId, width: width, // TODO: Remove `rest` props and use only what is explicitly in
                    // the API.
                    ...restCellProps } = cell;
                    const headCellId = `head-cell-${index}`;
                    const handleClick = ()=>{
                        this.setState({
                            activeSortButtonId: headCellId
                        });
                        if (isSortable) onSort(cell)();
                    };
                    return /*#__PURE__*/ (0, $8aG6j.jsx)(HeadCellComponent, {
                        colSpan: colSpan,
                        content: content,
                        isFixedSize: isFixedSize,
                        isIconOnlyHeader: isIconOnlyHeader,
                        isSortable: !!isSortable,
                        isRanking: isRanking,
                        headCellId: headCellId,
                        activeSortButtonId: activeSortButtonId,
                        onClick: handleClick,
                        testId: cellTestId || testId,
                        shouldTruncate: shouldTruncate,
                        sortOrder: key === sortKey ? sortOrder : undefined,
                        width: width,
                        ascendingSortTooltip: ascendingSortTooltip,
                        descendingSortTooltip: descendingSortTooltip,
                        buttonAriaRoleDescription: buttonAriaRoleDescription,
                        ...restCellProps
                    }, key || index);
                })
            })
        });
    }
    constructor(props){
        super(props);
        this.state = {
            activeSortButtonId: null
        };
    }
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$5be55afeb6489ab2$export$2e2bcd8739ae039 = $5be55afeb6489ab2$var$TableHead;


function $271a161443bda400$var$toggleSortOrder(currentSortOrder) {
    switch(currentSortOrder){
        case 'DESC':
            return 'ASC';
        case 'ASC':
            return 'DESC';
        default:
            return currentSortOrder;
    }
}
const $271a161443bda400$var$DynamicTable = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(97);
    const { caption: caption, head: head, highlightedRowIndex: highlightedRowIndex, rows: rows, sortKey: sortKey, sortOrder: sortOrder, loadingLabel: loadingLabel, onPageRowsUpdate: onPageRowsUpdate, testId: testId, totalRows: passedDownTotalRows, label: label, isLoading: t1, isFixedSize: t2, rowsPerPage: t3, onSetPage: t4, onSort: t5, page: t6, emptyView: emptyView, isRankable: t7, isRankingDisabled: t8, onRankStart: t9, onRankEnd: t10, loadingSpinnerSize: loadingSpinnerSize, paginationi18n: t11 } = t0;
    const isLoading = t1 === undefined ? false : t1;
    const isFixedSize = t2 === undefined ? false : t2;
    const rowsPerPage = t3 === undefined ? Infinity : t3;
    const onSetPage = t4 === undefined ? (0, $dpsRj.default) : t4;
    const providedOnSort = t5 === undefined ? (0, $dpsRj.default) : t5;
    const page = t6 === undefined ? 1 : t6;
    const isRankable = t7 === undefined ? false : t7;
    const isRankingDisabled = t8 === undefined ? false : t8;
    const onRankStart = t9 === undefined ? (0, $dpsRj.default) : t9;
    const providedOnRankEnd = t10 === undefined ? (0, $dpsRj.default) : t10;
    let t12;
    if ($[0] !== t11) {
        t12 = t11 === undefined ? {
            prev: "Previous Page",
            next: "Next Page",
            label: "Pagination",
            pageLabel: "Page"
        } : t11;
        $[0] = t11;
        $[1] = t12;
    } else t12 = $[1];
    const paginationi18n = t12;
    const [isRanking, setIsRanking] = (0, $cozmU.useState)(false);
    const tableBodyRef = (0, $cozmU.useRef)(null);
    let t13;
    if ($[2] !== providedOnSort) {
        t13 = {
            fn: providedOnSort,
            action: "sorted",
            componentName: "dynamicTable",
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local"
        };
        $[2] = providedOnSort;
        $[3] = t13;
    } else t13 = $[3];
    const onSort = (0, $7r5Hr.usePlatformLeafEventHandler)(t13);
    let t14;
    if ($[4] !== providedOnRankEnd) {
        t14 = {
            fn: providedOnRankEnd,
            action: "ranked",
            componentName: "dynamicTable",
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local"
        };
        $[4] = providedOnRankEnd;
        $[5] = t14;
    } else t14 = $[5];
    const onRankEnd = (0, $7r5Hr.usePlatformLeafEventHandler)(t14);
    let t15;
    let t16;
    if ($[6] !== head || $[7] !== sortKey) {
        t15 = ()=>{
            (0, $iHx0I.validateSortKey)(sortKey, head);
            (0, $8d7cd7e0bba12695$export$5eb35a4771ec4090)(head);
        };
        t16 = [
            sortKey,
            head
        ];
        $[6] = head;
        $[7] = sortKey;
        $[8] = t15;
        $[9] = t16;
    } else {
        t15 = $[8];
        t16 = $[9];
    }
    (0, $cozmU.useEffect)(t15, t16);
    let t17;
    if ($[10] !== isRankable || $[11] !== onSort || $[12] !== sortKey || $[13] !== sortOrder) {
        t17 = (item)=>()=>{
                const { key: key } = item;
                if (!key) return;
                if (onSort && isRankable && key === sortKey && sortOrder === "DESC") {
                    onSort({
                        key: null,
                        sortOrder: null,
                        item: item
                    });
                    return;
                }
                const sortOrderFormatted = key !== sortKey ? "ASC" : $271a161443bda400$var$toggleSortOrder(sortOrder);
                if (onSort) onSort({
                    key: key,
                    item: item,
                    sortOrder: sortOrderFormatted
                });
            };
        $[10] = isRankable;
        $[11] = onSort;
        $[12] = sortKey;
        $[13] = sortOrder;
        $[14] = t17;
    } else t17 = $[14];
    const onSortHandler = t17;
    let t18;
    if ($[15] !== onSetPage) {
        t18 = (page_0, event)=>{
            onSetPage(page_0, event);
        };
        $[15] = onSetPage;
        $[16] = t18;
    } else t18 = $[16];
    const onSetPageHandler = t18;
    let t19;
    if ($[17] !== onRankStart) {
        t19 = (params)=>{
            setIsRanking(true);
            onRankStart(params);
        };
        $[17] = onRankStart;
        $[18] = t19;
    } else t19 = $[18];
    const onRankStartHandler = t19;
    let t20;
    if ($[19] !== onRankEnd) {
        t20 = (params_0)=>{
            setIsRanking(false);
            onRankEnd(params_0);
        };
        $[19] = onRankEnd;
        $[20] = t20;
    } else t20 = $[20];
    const onRankEndHandler = t20;
    let t21;
    if ($[21] !== loadingSpinnerSize || $[22] !== page || $[23] !== rows || $[24] !== rowsPerPage) {
        t21 = ()=>{
            if (loadingSpinnerSize) return loadingSpinnerSize;
            return (0, $jfLxM.getPageRows)(rows || [], page, rowsPerPage).length > 2 ? "large" : "small";
        };
        $[21] = loadingSpinnerSize;
        $[22] = page;
        $[23] = rows;
        $[24] = rowsPerPage;
        $[25] = t21;
    } else t21 = $[25];
    const getSpinnerSize = t21;
    let t22;
    if ($[26] !== emptyView || $[27] !== isLoading || $[28] !== testId) {
        t22 = ()=>{
            if (isLoading) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $f90c20e8ccf48851$export$8f45b9407d4090d7), {
                testId: testId
            });
            return emptyView && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $e2f07650fad02bf8$export$381ea436de119582), {
                testId: testId,
                children: emptyView
            });
        };
        $[26] = emptyView;
        $[27] = isLoading;
        $[28] = testId;
        $[29] = t22;
    } else t22 = $[29];
    const renderEmptyBody = t22;
    const rowsLength = rows && rows.length;
    let totalPages;
    let isTotalPagesControlledExternally = false;
    if (passedDownTotalRows && Number.isInteger(passedDownTotalRows) && rowsPerPage && rowsLength && rowsLength <= passedDownTotalRows) {
        totalPages = Math.ceil(passedDownTotalRows / rowsPerPage);
        isTotalPagesControlledExternally = true;
    } else totalPages = rowsLength && rowsPerPage ? Math.ceil(rowsLength / rowsPerPage) : 0;
    totalPages = totalPages < 1 ? 1 : totalPages;
    const getPageNumber = page > totalPages ? totalPages : page;
    const rowsExist = !!rowsLength;
    let t23;
    if ($[30] !== getSpinnerSize) {
        t23 = getSpinnerSize();
        $[30] = getSpinnerSize;
        $[31] = t23;
    } else t23 = $[31];
    const spinnerSize = t23;
    let t24;
    if ($[32] !== renderEmptyBody) {
        t24 = renderEmptyBody();
        $[32] = renderEmptyBody;
        $[33] = t24;
    } else t24 = $[33];
    const emptyBody = t24;
    const t25 = isLoading && rowsExist;
    let t26;
    if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
        t26 = ()=>tableBodyRef.current;
        $[34] = t26;
    } else t26 = $[34];
    let t27;
    if ($[35] !== caption) {
        t27 = !!caption && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5c26b05e4fb09102$export$32fbfacc5d962e0c), {
            children: caption
        });
        $[35] = caption;
        $[36] = t27;
    } else t27 = $[36];
    let t28;
    if ($[37] !== head || $[38] !== isFixedSize || $[39] !== isRankable || $[40] !== isRanking || $[41] !== onSortHandler || $[42] !== sortKey || $[43] !== sortOrder || $[44] !== testId) {
        t28 = head && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5be55afeb6489ab2$export$2e2bcd8739ae039), {
            head: head,
            onSort: onSortHandler,
            sortKey: sortKey,
            sortOrder: sortOrder,
            isRanking: isRanking,
            isRankable: isRankable,
            isFixedSize: isFixedSize,
            testId: testId
        });
        $[37] = head;
        $[38] = isFixedSize;
        $[39] = isRankable;
        $[40] = isRanking;
        $[41] = onSortHandler;
        $[42] = sortKey;
        $[43] = sortOrder;
        $[44] = testId;
        $[45] = t28;
    } else t28 = $[45];
    let t29;
    if ($[46] !== getPageNumber || $[47] !== head || $[48] !== highlightedRowIndex || $[49] !== isFixedSize || $[50] !== isLoading || $[51] !== isRankable || $[52] !== isRanking || $[53] !== isRankingDisabled || $[54] !== isTotalPagesControlledExternally || $[55] !== onPageRowsUpdate || $[56] !== onRankEndHandler || $[57] !== onRankStartHandler || $[58] !== rows || $[59] !== rowsExist || $[60] !== rowsPerPage || $[61] !== sortKey || $[62] !== sortOrder || $[63] !== testId) {
        t29 = rowsExist && /*#__PURE__*/ (0, $8aG6j.jsx)($271a161443bda400$var$TableBody, {
            ref: tableBodyRef,
            highlightedRowIndex: highlightedRowIndex,
            rows: rows,
            head: head,
            sortKey: sortKey,
            sortOrder: sortOrder,
            rowsPerPage: rowsPerPage,
            page: getPageNumber,
            isFixedSize: isFixedSize || false,
            onPageRowsUpdate: onPageRowsUpdate,
            isTotalPagesControlledExternally: isTotalPagesControlledExternally,
            testId: testId,
            isRankable: isRankable,
            isRanking: isRanking,
            onRankStart: onRankStartHandler,
            onRankEnd: onRankEndHandler,
            isRankingDisabled: isRankingDisabled || isLoading || false
        });
        $[46] = getPageNumber;
        $[47] = head;
        $[48] = highlightedRowIndex;
        $[49] = isFixedSize;
        $[50] = isLoading;
        $[51] = isRankable;
        $[52] = isRanking;
        $[53] = isRankingDisabled;
        $[54] = isTotalPagesControlledExternally;
        $[55] = onPageRowsUpdate;
        $[56] = onRankEndHandler;
        $[57] = onRankStartHandler;
        $[58] = rows;
        $[59] = rowsExist;
        $[60] = rowsPerPage;
        $[61] = sortKey;
        $[62] = sortOrder;
        $[63] = testId;
        $[64] = t29;
    } else t29 = $[64];
    let t30;
    if ($[65] !== isFixedSize || $[66] !== isLoading || $[67] !== label || $[68] !== rowsExist || $[69] !== t27 || $[70] !== t28 || $[71] !== t29 || $[72] !== testId) {
        t30 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $7f9cc963fb218178$export$54ec01a60f47d33d), {
            isFixedSize: isFixedSize,
            "aria-label": label,
            hasDataRow: rowsExist,
            testId: testId,
            isLoading: isLoading,
            children: [
                t27,
                t28,
                t29
            ]
        });
        $[65] = isFixedSize;
        $[66] = isLoading;
        $[67] = label;
        $[68] = rowsExist;
        $[69] = t27;
        $[70] = t28;
        $[71] = t29;
        $[72] = testId;
        $[73] = t30;
    } else t30 = $[73];
    let t31;
    if ($[74] !== loadingLabel || $[75] !== spinnerSize || $[76] !== t25 || $[77] !== t30 || $[78] !== testId) {
        t31 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $894542bbf1d55048$export$2e2bcd8739ae039), {
            isLoading: t25,
            spinnerSize: spinnerSize,
            targetRef: t26,
            testId: testId,
            loadingLabel: loadingLabel,
            children: t30
        });
        $[74] = loadingLabel;
        $[75] = spinnerSize;
        $[76] = t25;
        $[77] = t30;
        $[78] = testId;
        $[79] = t31;
    } else t31 = $[79];
    let t32;
    if ($[80] !== getPageNumber || $[81] !== isLoading || $[82] !== onSetPageHandler || $[83] !== paginationi18n || $[84] !== testId || $[85] !== totalPages) {
        t32 = totalPages <= 1 ? null : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2fd7e9f40e2b519d$export$3e5e12dc01f20a43), {
            testId: testId,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $057a9e1bf87f03b7$export$2e2bcd8739ae039), {
                value: getPageNumber,
                onChange: onSetPageHandler,
                total: totalPages,
                i18n: paginationi18n,
                isDisabled: isLoading,
                testId: testId
            })
        });
        $[80] = getPageNumber;
        $[81] = isLoading;
        $[82] = onSetPageHandler;
        $[83] = paginationi18n;
        $[84] = testId;
        $[85] = totalPages;
        $[86] = t32;
    } else t32 = $[86];
    let t33;
    if ($[87] !== emptyBody || $[88] !== isLoading || $[89] !== loadingLabel || $[90] !== rowsExist || $[91] !== testId) {
        t33 = !rowsExist && emptyBody && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1f3230d9ef7343db$export$2e2bcd8739ae039), {
            isLoading: isLoading,
            spinnerSize: "large",
            testId: testId,
            loadingLabel: loadingLabel,
            children: emptyBody
        });
        $[87] = emptyBody;
        $[88] = isLoading;
        $[89] = loadingLabel;
        $[90] = rowsExist;
        $[91] = testId;
        $[92] = t33;
    } else t33 = $[92];
    let t34;
    if ($[93] !== t31 || $[94] !== t32 || $[95] !== t33) {
        t34 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
            children: [
                t31,
                t32,
                t33
            ]
        });
        $[93] = t31;
        $[94] = t32;
        $[95] = t33;
        $[96] = t34;
    } else t34 = $[96];
    return t34;
} : ({ caption: caption, head: head, highlightedRowIndex: highlightedRowIndex, rows: rows, sortKey: sortKey, sortOrder: sortOrder, loadingLabel: loadingLabel, onPageRowsUpdate: onPageRowsUpdate, testId: testId, totalRows: passedDownTotalRows, label: label, isLoading: isLoading = false, isFixedSize: isFixedSize = false, rowsPerPage: rowsPerPage = Infinity, onSetPage: onSetPage = (0, $dpsRj.default), onSort: providedOnSort = (0, $dpsRj.default), page: page = 1, emptyView: emptyView, isRankable: isRankable = false, isRankingDisabled: isRankingDisabled = false, onRankStart: onRankStart = (0, $dpsRj.default), onRankEnd: providedOnRankEnd = (0, $dpsRj.default), loadingSpinnerSize: loadingSpinnerSize, paginationi18n: paginationi18n = {
    prev: 'Previous Page',
    next: 'Next Page',
    label: 'Pagination',
    pageLabel: 'Page'
} })=>{
    const [isRanking, setIsRanking] = (0, $cozmU.useState)(false);
    const tableBodyRef = (0, $cozmU.useRef)(null);
    const onSort = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: providedOnSort,
        action: 'sorted',
        componentName: 'dynamicTable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const onRankEnd = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: providedOnRankEnd,
        action: 'ranked',
        componentName: 'dynamicTable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    (0, $cozmU.useEffect)(()=>{
        (0, $iHx0I.validateSortKey)(sortKey, head);
        (0, $8d7cd7e0bba12695$export$5eb35a4771ec4090)(head);
    }, [
        sortKey,
        head
    ]);
    const onSortHandler = (item)=>()=>{
            const { key: key } = item;
            if (!key) return;
            if (onSort && isRankable && key === sortKey && sortOrder === 'DESC') {
                onSort({
                    key: null,
                    sortOrder: null,
                    item: item
                });
                return;
            }
            const sortOrderFormatted = key !== sortKey ? 'ASC' : $271a161443bda400$var$toggleSortOrder(sortOrder);
            if (onSort) onSort({
                key: key,
                item: item,
                sortOrder: sortOrderFormatted
            });
        };
    const onSetPageHandler = (page_0, event)=>{
        onSetPage(page_0, event);
    };
    const onRankStartHandler = (params)=>{
        setIsRanking(true);
        onRankStart(params);
    };
    const onRankEndHandler = (params_0)=>{
        setIsRanking(false);
        onRankEnd(params_0);
    };
    const getSpinnerSize = ()=>{
        if (loadingSpinnerSize) return loadingSpinnerSize;
        return (0, $jfLxM.getPageRows)(rows || [], page, rowsPerPage).length > 2 ? 'large' : 'small';
    };
    const renderEmptyBody = ()=>{
        if (isLoading) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $f90c20e8ccf48851$export$8f45b9407d4090d7), {
            testId: testId
        });
        return emptyView && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $e2f07650fad02bf8$export$381ea436de119582), {
            testId: testId,
            children: emptyView
        });
    };
    const rowsLength = rows && rows.length;
    let totalPages;
    // set a flag to denote the dynamic table might get only one page of data
    // for paginated data
    let isTotalPagesControlledExternally = false;
    if (passedDownTotalRows && Number.isInteger(passedDownTotalRows) && rowsPerPage && rowsLength && rowsLength <= passedDownTotalRows) {
        /**
     * If total number of rows / records have been passed down as prop
     * Then table is being fed paginated data from server or other sources
     * In this case, we want to respect information passed down by server or external source
     * Rather than relying on our computation based on number of rows
     */ totalPages = Math.ceil(passedDownTotalRows / rowsPerPage);
        isTotalPagesControlledExternally = true;
    } else totalPages = rowsLength && rowsPerPage ? Math.ceil(rowsLength / rowsPerPage) : 0;
    totalPages = totalPages < 1 ? 1 : totalPages;
    const getPageNumber = page > totalPages ? totalPages : page; // page! required, because typescript can't yet see defaultProps to know that this won't be undefined
    const rowsExist = !!rowsLength;
    const spinnerSize = getSpinnerSize();
    const emptyBody = renderEmptyBody();
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $894542bbf1d55048$export$2e2bcd8739ae039), {
                isLoading: isLoading && rowsExist,
                spinnerSize: spinnerSize,
                targetRef: ()=>tableBodyRef.current,
                testId: testId,
                loadingLabel: loadingLabel,
                children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $7f9cc963fb218178$export$54ec01a60f47d33d), {
                    isFixedSize: isFixedSize,
                    "aria-label": label,
                    hasDataRow: rowsExist,
                    testId: testId,
                    isLoading: isLoading,
                    children: [
                        !!caption && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5c26b05e4fb09102$export$32fbfacc5d962e0c), {
                            children: caption
                        }),
                        head && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5be55afeb6489ab2$export$2e2bcd8739ae039), {
                            head: head,
                            onSort: onSortHandler,
                            sortKey: sortKey,
                            sortOrder: sortOrder,
                            isRanking: isRanking,
                            isRankable: isRankable,
                            isFixedSize: isFixedSize,
                            testId: testId
                        }),
                        rowsExist && /*#__PURE__*/ (0, $8aG6j.jsx)($271a161443bda400$var$TableBody, {
                            ref: tableBodyRef,
                            highlightedRowIndex: highlightedRowIndex,
                            rows: rows,
                            head: head,
                            sortKey: sortKey,
                            sortOrder: sortOrder,
                            rowsPerPage: rowsPerPage,
                            page: getPageNumber,
                            isFixedSize: isFixedSize || false,
                            onPageRowsUpdate: onPageRowsUpdate,
                            isTotalPagesControlledExternally: isTotalPagesControlledExternally,
                            testId: testId,
                            isRankable: isRankable,
                            isRanking: isRanking,
                            onRankStart: onRankStartHandler,
                            onRankEnd: onRankEndHandler,
                            isRankingDisabled: isRankingDisabled || isLoading || false
                        })
                    ]
                })
            }),
            totalPages <= 1 ? null : // only show pagination if there's MORE than 1 page
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2fd7e9f40e2b519d$export$3e5e12dc01f20a43), {
                testId: testId,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $057a9e1bf87f03b7$export$2e2bcd8739ae039), {
                    value: getPageNumber,
                    onChange: onSetPageHandler,
                    total: totalPages,
                    i18n: paginationi18n,
                    isDisabled: isLoading,
                    testId: testId
                })
            }),
            !rowsExist && emptyBody && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1f3230d9ef7343db$export$2e2bcd8739ae039), {
                isLoading: isLoading,
                spinnerSize: "large",
                testId: testId,
                loadingLabel: loadingLabel,
                children: emptyBody
            })
        ]
    });
};

const $271a161443bda400$var$RankableTableBody = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("b6DGi")));
const $271a161443bda400$var$TableBody = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? function TableBody(t0, ref) {
    const $ = (0, $bDgLe.c)(23);
    let bodyProps;
    let isRanking;
    let isRankingDisabled;
    let onRankEnd;
    let onRankStart;
    let t1;
    if ($[0] !== t0) {
        ({ isRankable: t1, isRanking: isRanking, onRankStart: onRankStart, onRankEnd: onRankEnd, isRankingDisabled: isRankingDisabled, ...bodyProps } = t0);
        $[0] = t0;
        $[1] = bodyProps;
        $[2] = isRanking;
        $[3] = isRankingDisabled;
        $[4] = onRankEnd;
        $[5] = onRankStart;
        $[6] = t1;
    } else {
        bodyProps = $[1];
        isRanking = $[2];
        isRankingDisabled = $[3];
        onRankEnd = $[4];
        onRankStart = $[5];
        t1 = $[6];
    }
    const isRankable = t1 === undefined ? false : t1;
    const canRank = isRankable && !bodyProps.sortKey;
    const [canRenderRankable, setCanRenderRankable] = (0, $cozmU.useState)(false);
    let t2;
    let t3;
    if ($[7] !== canRank) {
        t2 = ()=>{
            if (canRank) setCanRenderRankable(true);
        };
        t3 = [
            canRank
        ];
        $[7] = canRank;
        $[8] = t2;
        $[9] = t3;
    } else {
        t2 = $[8];
        t3 = $[9];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    if ($[10] !== bodyProps || $[11] !== ref) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cc2c87abcc03b65c$export$2e2bcd8739ae039), {
            ref: ref,
            ...bodyProps
        });
        $[10] = bodyProps;
        $[11] = ref;
        $[12] = t4;
    } else t4 = $[12];
    const nonRankableBody = t4;
    let t5;
    if ($[13] !== bodyProps || $[14] !== canRank || $[15] !== canRenderRankable || $[16] !== isRanking || $[17] !== isRankingDisabled || $[18] !== nonRankableBody || $[19] !== onRankEnd || $[20] !== onRankStart || $[21] !== ref) {
        t5 = canRank && canRenderRankable ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $adc4070934df864d$export$e926676385687eaf), {
            fallback: nonRankableBody,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
                fallback: nonRankableBody,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)($271a161443bda400$var$RankableTableBody, {
                    ref: ref,
                    ...bodyProps,
                    isRanking: isRanking,
                    onRankStart: onRankStart,
                    onRankEnd: onRankEnd,
                    isRankingDisabled: isRankingDisabled
                })
            })
        }) : nonRankableBody;
        $[13] = bodyProps;
        $[14] = canRank;
        $[15] = canRenderRankable;
        $[16] = isRanking;
        $[17] = isRankingDisabled;
        $[18] = nonRankableBody;
        $[19] = onRankEnd;
        $[20] = onRankStart;
        $[21] = ref;
        $[22] = t5;
    } else t5 = $[22];
    return t5;
} : function TableBody({ isRankable: isRankable = false, isRanking: isRanking, onRankStart: onRankStart, onRankEnd: onRankEnd, isRankingDisabled: isRankingDisabled, ...bodyProps }, ref) {
    const canRank = isRankable && !bodyProps.sortKey;
    /**
   * React 16 does not support SSR for lazy components,
   * so we avoid rendering the `Suspense` on the server.
   */ const [canRenderRankable, setCanRenderRankable] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        if (canRank) setCanRenderRankable(true);
    }, [
        canRank
    ]);
    const nonRankableBody = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cc2c87abcc03b65c$export$2e2bcd8739ae039), {
        ref: ref,
        ...bodyProps
    });
    return canRank && canRenderRankable ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $adc4070934df864d$export$e926676385687eaf), {
        fallback: nonRankableBody,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
            fallback: nonRankableBody,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)($271a161443bda400$var$RankableTableBody, {
                ref: ref,
                ...bodyProps,
                isRanking: isRanking,
                onRankStart: onRankStart,
                onRankEnd: onRankEnd,
                isRankingDisabled: isRankingDisabled
            })
        })
    }) : nonRankableBody;
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$271a161443bda400$export$2e2bcd8739ae039 = $271a161443bda400$var$DynamicTable;
module.exports["default"] = $271a161443bda400$export$2e2bcd8739ae039;

});

parcelRegister("6LhkM", function(module, exports) {
$parcel$export(module.exports, "default", () => $f7cbe3c10c3705da$export$2e2bcd8739ae039);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $jfLxM = parcelRequire("jfLxM");


var $iHx0I = parcelRequire("iHx0I");

const $f7cbe3c10c3705da$var$getSortingCellValue = (cells, head, sortKey)=>{
    for(let i = 0; i < cells.length; i++){
        if (head.cells[i] && head.cells[i]?.key === sortKey) return cells[i]?.key;
    }
    return undefined;
};
// sort all rows based on sort key and order
const $f7cbe3c10c3705da$var$getSortedRows = (head, rows, sortKey, sortOrder)=>{
    if (!sortKey || !head) return rows;
    if (!rows) return [];
    const modifier = sortOrder === 'ASC' ? 1 : -1;
    // Re-initialising an I18n Collator on every sort is performance intensive, thus constructed outside
    const collator = new Intl.Collator(undefined, {
        numeric: true,
        sensitivity: 'accent'
    });
    // Get copy of rows to avoid sorting prop in place
    const sortableRows = Array.from(rows);
    // Reorder rows in table based on sorting cell value
    // Algorithm will sort numerics or strings, but not both
    return sortableRows.sort((a, b)=>{
        const valA = $f7cbe3c10c3705da$var$getSortingCellValue(a.cells, head, sortKey);
        const valB = $f7cbe3c10c3705da$var$getSortingCellValue(b.cells, head, sortKey);
        if (valA === undefined || valB === undefined) return modifier;
        if (typeof valA !== typeof valB) {
            // numbers are always grouped higher in the sort
            if (typeof valA === 'number') return -1;
            if (typeof valB === 'number') return 1;
            // strings are grouped next
            if (typeof valA === 'string') return -1;
            if (typeof valB === 'string') return 1;
        }
        if (typeof valA === 'string' && typeof valB === 'string') return modifier * collator.compare(valA, valB);
        if (!valA && valA !== 0 || valA < valB) return -modifier;
        if (!valB && valB !== 0 || valA > valB) return modifier;
        if (valA === valB) return 0;
        return 1;
    });
};
function $f7cbe3c10c3705da$export$2e2bcd8739ae039(WrappedComponent) {
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class WithSortedPageRows extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
        static getDerivedStateFromProps(props, state) {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, page: page, rowsPerPage: rowsPerPage, isTotalPagesControlledExternally: isTotalPagesControlledExternally } = props;
            (0, $iHx0I.validateSortKey)(sortKey, head);
            let sortedRows;
            let pageRows;
            if (isTotalPagesControlledExternally) {
                sortedRows = rows;
                pageRows = rows;
            } else {
                sortedRows = $f7cbe3c10c3705da$var$getSortedRows(head, rows, sortKey, sortOrder) || [];
                pageRows = (0, $jfLxM.getPageRows)(sortedRows, page, rowsPerPage);
            }
            return {
                ...state,
                pageRows: pageRows
            };
        }
        componentDidMount() {
            this.props.onPageRowsUpdate && this.props.onPageRowsUpdate(this.state.pageRows);
        }
        componentDidUpdate(_prevProps, prevState) {
            if (this.props.onPageRowsUpdate && this.state.pageRows !== prevState.pageRows) this.props.onPageRowsUpdate(this.state.pageRows);
        }
        render() {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, rowsPerPage: rowsPerPage, page: page, forwardedRef: forwardedRef, ...restProps } = this.props;
            return /*#__PURE__*/ (0, $8aG6j.jsx)(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                pageRows: this.state.pageRows,
                head: head,
                ...restProps,
                ref: forwardedRef
            });
        }
        constructor(...args){
            super(...args);
            this.state = {
                pageRows: []
            };
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
        const $ = (0, $bDgLe.c)(3);
        let t0;
        if ($[0] !== props || $[1] !== ref) {
            t0 = /*#__PURE__*/ (0, $8aG6j.jsx)(WithSortedPageRows, {
                ...props,
                forwardedRef: ref
            });
            $[0] = props;
            $[1] = ref;
            $[2] = t0;
        } else t0 = $[2];
        return t0;
    } : (props, ref)=>{
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
        return /*#__PURE__*/ (0, $8aG6j.jsx)(WithSortedPageRows, {
            ...props,
            forwardedRef: ref
        });
    });
}

});

parcelRegister("3Cyjf", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $aKm7d = parcelRequire("aKm7d");

const $cf3a304d4ce74d69$var$fixedSizeTruncateStyles = null;
const $cf3a304d4ce74d69$var$overflowTruncateStyles = null;
const $cf3a304d4ce74d69$var$truncationWidthStyles = null;
const $cf3a304d4ce74d69$var$cellStyles = null; // eslint-disable-next-line @repo/internal/react/require-jsdoc
const $cf3a304d4ce74d69$export$948e91fcef170792 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    let props;
    let t1;
    let t2;
    let t3;
    if ($[0] !== t0) {
        const { width: width, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, innerRef: innerRef, ...t4 } = t0;
        props = t4;
        let t5;
        if ($[5] !== width) {
            t5 = (0, $aKm7d.getTruncationStyleVars)({
                width: width
            });
            $[5] = width;
            $[6] = t5;
        } else t5 = $[6];
        t1 = t5;
        t2 = innerRef;
        t3 = (0, $hekY6.default)([
            "_39xV02SBlE",
            isFixedSize && shouldTruncate && "_39HuIbz8Lp _1ANEUSLRg7",
            isFixedSize && "_4bt5LAnQyn _2WAcuGnQyn",
            "_30huDKYbGa _0xmtko1Y8M _46hvQm1Y8M _03SyCP2ADO _0LQT5E2ADO _2fwxA5ecOK _4efXyCPgdg _22fNSnPgdg",
            props.className
        ]);
        $[0] = t0;
        $[1] = props;
        $[2] = t1;
        $[3] = t2;
        $[4] = t3;
    } else {
        props = $[1];
        t1 = $[2];
        t2 = $[3];
        t3 = $[4];
    }
    let t4;
    if ($[7] !== props || $[8] !== t1 || $[9] !== t2 || $[10] !== t3) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)("td", {
            style: t1,
            ref: t2,
            className: t3,
            ...props
        });
        $[7] = props;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
    } else t4 = $[11];
    return t4;
} : ({ width: width, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, innerRef: innerRef, ...props })=>/*#__PURE__*/ (0, $8aG6j.jsx)("td" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    , {
        style: (0, $aKm7d.getTruncationStyleVars)({
            width: width
        }),
        // @ts-ignore
        ref: innerRef,
        className: (0, $hekY6.default)([
            "_39xV02SBlE",
            isFixedSize && shouldTruncate && "_39HuIbz8Lp _1ANEUSLRg7",
            isFixedSize && "_4bt5LAnQyn _2WAcuGnQyn",
            "_30huDKYbGa _0xmtko1Y8M _46hvQm1Y8M _03SyCP2ADO _0LQT5E2ADO _2fwxA5ecOK _4efXyCPgdg _22fNSnPgdg",
            props.className
        ]),
        ...props
    });
module.exports["TableBodyCell"] = $cf3a304d4ce74d69$export$948e91fcef170792;

});

parcelRegister("fNX95", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $bc6f4bd33d2d03cf$var$rowStyles = null;
const $bc6f4bd33d2d03cf$var$rowBackgroundStyles = null;
const $bc6f4bd33d2d03cf$var$rowHighlightedBackgroundStyles = null; // eslint-disable-next-line @repo/internal/react/require-jsdoc
const $bc6f4bd33d2d03cf$export$45f39d9c38b886d5 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(17);
    let children;
    let className;
    let isHighlighted;
    let rest;
    let style;
    let testId;
    if ($[0] !== t0) {
        ({ isHighlighted: isHighlighted, children: children, style: style, testId: testId, className: className, ...rest } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = className;
        $[3] = isHighlighted;
        $[4] = rest;
        $[5] = style;
        $[6] = testId;
    } else {
        children = $[1];
        className = $[2];
        isHighlighted = $[3];
        rest = $[4];
        style = $[5];
        testId = $[6];
    }
    const t1 = isHighlighted ? "_0KLXruY9q9 _1eOmH6sumd" : "_1eOmH6o126";
    let t2;
    if ($[7] !== className || $[8] !== t1) {
        t2 = (0, $hekY6.default)([
            "_0KLXru66of _4EiLyUXzJH _34b3D2pgTj",
            t1,
            className
        ]);
        $[7] = className;
        $[8] = t1;
        $[9] = t2;
    } else t2 = $[9];
    let t3;
    if ($[10] !== children || $[11] !== ref || $[12] !== rest || $[13] !== style || $[14] !== t2 || $[15] !== testId) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)("tr", {
            style: style,
            className: t2,
            ...rest,
            ref: ref,
            "data-testid": testId,
            children: children
        });
        $[10] = children;
        $[11] = ref;
        $[12] = rest;
        $[13] = style;
        $[14] = t2;
        $[15] = testId;
        $[16] = t3;
    } else t3 = $[16];
    return t3;
} : ({ isHighlighted: isHighlighted, children: children, style: style, testId: testId, className: className, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)("tr", {
        style: style,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hekY6.default)([
            "_0KLXru66of _4EiLyUXzJH _34b3D2pgTj",
            isHighlighted ? "_0KLXruY9q9 _1eOmH6sumd" : "_1eOmH6o126",
            className
        ]),
        ...rest,
        ref: ref,
        "data-testid": testId,
        children: children
    });
});
module.exports["TableBodyRow"] = $bc6f4bd33d2d03cf$export$45f39d9c38b886d5;

});

parcelRegister("4kJeN", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7r5Hr = parcelRequire("7r5Hr");


var $dpsRj = parcelRequire("dpsRj");


var $5Dlqn = parcelRequire("5Dlqn");


var $iW7aI = parcelRequire("iW7aI");


var $aDSIl = parcelRequire("aDSIl");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");










parcelRequire("cozmU");


var $7ZB0A = parcelRequire("7ZB0A");

const $17f3d644edf8e222$var$Navigator = (0, $gtMdU.isReactCompilerActivePlatform)() ? function Navigator(props) {
    const $ = (0, $bDgLe.c)(7);
    const t0 = props["aria-label"];
    let t1;
    if ($[0] !== props.component || $[1] !== props.iconBefore || $[2] !== props.isDisabled || $[3] !== props.onClick || $[4] !== props.testId || $[5] !== t0) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7ZB0A.default), {
            "aria-label": t0,
            isDisabled: props.isDisabled,
            iconBefore: props.iconBefore,
            testId: props.testId,
            onClick: props.onClick,
            component: props.component,
            appearance: "subtle"
        });
        $[0] = props.component;
        $[1] = props.iconBefore;
        $[2] = props.isDisabled;
        $[3] = props.onClick;
        $[4] = props.testId;
        $[5] = t0;
        $[6] = t1;
    } else t1 = $[6];
    return t1;
} : function Navigator(props) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7ZB0A.default), {
        "aria-label": props['aria-label'],
        isDisabled: props.isDisabled,
        iconBefore: props.iconBefore,
        testId: props.testId,
        onClick: props.onClick,
        component: props.component,
        appearance: "subtle"
    });
};
var $17f3d644edf8e222$export$2e2bcd8739ae039 = $17f3d644edf8e222$var$Navigator;











parcelRequire("cozmU");




const $c982ffc605b50884$var$Page = (0, $gtMdU.isReactCompilerActivePlatform)() ? function Page(props) {
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7ZB0A.default), {
            ...props,
            appearance: "subtle"
        });
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : function Page(props) {
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7ZB0A.default), {
        ...props,
        appearance: "subtle"
    });
};
var $c982ffc605b50884$export$2e2bcd8739ae039 = $c982ffc605b50884$var$Page;


/* render-ellipsis.tsx generated by @compiled/babel-plugin v3.0.2 */ 


parcelRequire("cozmU");




var $4aRua = parcelRequire("4aRua");


var $9GVkD = parcelRequire("9GVkD");

const $704f330cc7acd87d$var$styles = {
    container: "_3iDTPbQ4SZ _1mT5xdRAKS"
};
function $704f330cc7acd87d$export$2e2bcd8739ae039({ key: key, testId: testId, from: from, to: to }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        as: "li",
        testId: testId,
        xcss: $704f330cc7acd87d$var$styles.container,
        paddingInline: "space.100",
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $4aRua.Text), {
            testId: testId && `${testId}-text`,
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $9GVkD.default), {
                    children: [
                        "Skipped pages from ",
                        from,
                        " to ",
                        to
                    ]
                }),
                "\u2026"
            ]
        })
    }, key);
}


const $4a66713043ed72c4$export$3f860eba1218f8d3 = {};



var $dOBRD = parcelRequire("dOBRD");

// TODO: comma needed after generic declaration below, or the .tsx file thinks
// it is a JSX element. Tidy up in a future refactor.
const $a160bbcb7aa35a3d$var$collapseRange = (pages, current, { max: max, ellipsis: ellipsis, transform: transform }, testId)=>{
    const total = pages.length;
    // only need ellipsis if we have more pages than we can display
    const needEllipsis = total > max;
    // show start ellipsis if the current page is further away than max - 4 from the first page
    const hasStartEllipsis = needEllipsis && max - 4 < current;
    // show end ellipsis if the current page is further than total - max + 3 from the last page
    const hasEndEllipsis = needEllipsis && current < total - max + 3;
    const getPageComponents = (0, $dOBRD.default)((startIndex = 0, lastIndex = total)=>{
        return pages.slice(startIndex, lastIndex).map((page, index)=>transform(page, startIndex + index, testId));
    });
    if (!needEllipsis) return getPageComponents(0, total);
    if (hasStartEllipsis && !hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, 1),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: 2,
                to: total - pageCount
            }),
            ...getPageComponents(total - pageCount)
        ];
    }
    if (!hasStartEllipsis && hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, pageCount),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: pageCount + 1,
                to: total - 1
            }),
            ...getPageComponents(total - 1)
        ];
    }
    // we have both start and end ellipsis
    const pageCount = max - 4;
    return [
        ...getPageComponents(0, 1),
        ellipsis({
            key: 'ellipsis-1',
            testId: testId && `${testId}-ellipsis`,
            from: 2,
            to: current - Math.floor(pageCount / 2)
        }),
        ...getPageComponents(current - Math.floor(pageCount / 2), current + pageCount - 1),
        ellipsis({
            key: 'ellipsis-2',
            testId: testId && `${testId}-ellipsis`,
            from: current + 3,
            to: total - 1
        }),
        ...getPageComponents(total - 1)
    ];
};
var $a160bbcb7aa35a3d$export$2e2bcd8739ae039 = $a160bbcb7aa35a3d$var$collapseRange;


const $58ee79fc5bef7c86$var$styles = {
    paginationMenu: "_46hvQmPgdg _03SyCPPgdg _0xmtkoPgdg _0LQT5EPgdg _43nrzTPgdg _2xTnZxPgdg _0rIjykPgdg _0GTcwRPgdg",
    paginationMenuItem: "_43nrzTPgdg _0WKd3G4z3T",
    navigatorIconWrapper: "_2Y7lL4gVvo"
};
const $58ee79fc5bef7c86$var$analyticsAttributes = {
    componentName: 'pagination',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $58ee79fc5bef7c86$var$NavigatorIcon = (0, $gtMdU.isReactCompilerActivePlatform)() ? function NavigatorIcon(t0) {
    const $ = (0, $bDgLe.c)(2);
    const { chevronDirection: chevronDirection } = t0;
    const Chevron = chevronDirection === "left" ? (0, (/*@__PURE__*/$parcel$interopDefault($iW7aI))) : (0, (/*@__PURE__*/$parcel$interopDefault($aDSIl)));
    let t1;
    if ($[0] !== Chevron) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            as: "span",
            xcss: $58ee79fc5bef7c86$var$styles.navigatorIconWrapper,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)(Chevron, {
                label: "",
                color: "currentColor",
                size: "small"
            })
        });
        $[0] = Chevron;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : function NavigatorIcon({ chevronDirection: chevronDirection }) {
    const Chevron = chevronDirection === 'left' ? (0, (/*@__PURE__*/$parcel$interopDefault($iW7aI))) : (0, (/*@__PURE__*/$parcel$interopDefault($aDSIl)));
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        as: "span",
        xcss: $58ee79fc5bef7c86$var$styles.navigatorIconWrapper,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)(Chevron, {
            label: "",
            color: "currentColor",
            size: "small"
        })
    });
};
const $58ee79fc5bef7c86$var$InnerPagination = (0, $gtMdU.isReactCompilerActivePlatform)() ? function InnerPagination(t0, ref) {
    const $ = (0, $bDgLe.c)(57);
    const { components: t1, defaultSelectedIndex: t2, selectedIndex: selectedIndex, label: t3, pageLabel: t4, previousLabel: t5, nextLabel: t6, style: t7, max: t8, onChange: t9, pages: pages, getPageLabel: getPageLabel, renderEllipsis: t10, analyticsContext: analyticsContext, testId: testId, isDisabled: isDisabled } = t0;
    const components = t1 === undefined ? (0, $4a66713043ed72c4$export$3f860eba1218f8d3) : t1;
    const defaultSelectedIndex = t2 === undefined ? 0 : t2;
    const label = t3 === undefined ? "pagination" : t3;
    const pageLabel = t4 === undefined ? "page" : t4;
    const previousLabel = t5 === undefined ? "previous" : t5;
    const nextLabel = t6 === undefined ? "next" : t6;
    const style = t7 === undefined ? (0, $4a66713043ed72c4$export$3f860eba1218f8d3) : t7;
    const max = t8 === undefined ? 7 : t8;
    const onChange = t9 === undefined ? (0, $dpsRj.default) : t9;
    const renderEllipsis = t10 === undefined ? (0, $704f330cc7acd87d$export$2e2bcd8739ae039) : t10;
    let t11;
    if ($[0] !== defaultSelectedIndex) {
        t11 = ()=>defaultSelectedIndex || 0;
        $[0] = defaultSelectedIndex;
        $[1] = t11;
    } else t11 = $[1];
    const [selectedIndexValue, setSelectedIndexValue] = (0, $5Dlqn.default)(selectedIndex, t11);
    let t12;
    if ($[2] !== onChange || $[3] !== pages || $[4] !== selectedIndex || $[5] !== setSelectedIndexValue) {
        t12 = (value, analyticsEvent)=>{
            const { event: event, selectedPageIndex: selectedPageIndex } = value;
            if (selectedIndex === undefined) setSelectedIndexValue(selectedPageIndex);
            if (onChange) onChange(event, pages[selectedPageIndex], analyticsEvent);
        };
        $[2] = onChange;
        $[3] = pages;
        $[4] = selectedIndex;
        $[5] = setSelectedIndexValue;
        $[6] = t12;
    } else t12 = $[6];
    let t13;
    if ($[7] !== analyticsContext || $[8] !== t12) {
        t13 = {
            fn: t12,
            action: "changed",
            actionSubject: "pageNumber",
            analyticsData: analyticsContext,
            ...$58ee79fc5bef7c86$var$analyticsAttributes
        };
        $[7] = analyticsContext;
        $[8] = t12;
        $[9] = t13;
    } else t13 = $[9];
    const onChangeWithAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)(t13);
    let t14;
    if ($[10] !== components.Page || $[11] !== getPageLabel || $[12] !== isDisabled || $[13] !== onChangeWithAnalytics || $[14] !== pageLabel || $[15] !== pages || $[16] !== selectedIndexValue) {
        t14 = (page, currPageIndex, testId_0)=>{
            const selectedPage = pages[selectedIndexValue];
            const pageIndexLabel = `${pageLabel} ${getPageLabel ? getPageLabel(page, currPageIndex) : page}`;
            const isCurrentPage = page === selectedPage;
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1l0kj.Inline), {
                as: "li",
                xcss: $58ee79fc5bef7c86$var$styles.paginationMenuItem,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $c982ffc605b50884$export$2e2bcd8739ae039), {
                    component: components.Page,
                    onClick: (event_0)=>onChangeWithAnalytics({
                            event: event_0,
                            selectedPageIndex: currPageIndex
                        }),
                    "aria-current": isCurrentPage ? "page" : undefined,
                    "aria-label": pageIndexLabel,
                    isSelected: isCurrentPage,
                    isDisabled: isDisabled,
                    page: page,
                    testId: testId_0 && `${testId_0}--${isCurrentPage ? "current-" : ""}page-${currPageIndex}`,
                    children: getPageLabel ? getPageLabel(page, currPageIndex) : page
                })
            }, `page-${getPageLabel ? getPageLabel(page, currPageIndex) : currPageIndex}`);
        };
        $[10] = components.Page;
        $[11] = getPageLabel;
        $[12] = isDisabled;
        $[13] = onChangeWithAnalytics;
        $[14] = pageLabel;
        $[15] = pages;
        $[16] = selectedIndexValue;
        $[17] = t14;
    } else t14 = $[17];
    const transform = t14;
    let t15;
    if ($[18] !== onChangeWithAnalytics || $[19] !== selectedIndexValue) {
        t15 = (event_1)=>onChangeWithAnalytics({
                event: event_1,
                selectedPageIndex: selectedIndexValue - 1
            });
        $[18] = onChangeWithAnalytics;
        $[19] = selectedIndexValue;
        $[20] = t15;
    } else t15 = $[20];
    const t16 = isDisabled || selectedIndexValue === 0;
    let t17;
    if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
        t17 = /*#__PURE__*/ (0, $8aG6j.jsx)($58ee79fc5bef7c86$var$NavigatorIcon, {
            chevronDirection: "left"
        });
        $[21] = t17;
    } else t17 = $[21];
    const t18 = testId && `${testId}--left-navigator`;
    let t19;
    if ($[22] !== components.Previous || $[23] !== previousLabel || $[24] !== t15 || $[25] !== t16 || $[26] !== t18) {
        t19 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $17f3d644edf8e222$export$2e2bcd8739ae039), {
            component: components.Previous,
            onClick: t15,
            isDisabled: t16,
            iconBefore: t17,
            "aria-label": previousLabel,
            testId: t18
        }, "left-navigator");
        $[22] = components.Previous;
        $[23] = previousLabel;
        $[24] = t15;
        $[25] = t16;
        $[26] = t18;
        $[27] = t19;
    } else t19 = $[27];
    let t20;
    if ($[28] !== max || $[29] !== pages || $[30] !== renderEllipsis || $[31] !== selectedIndexValue || $[32] !== testId || $[33] !== transform) {
        t20 = (0, $a160bbcb7aa35a3d$export$2e2bcd8739ae039)(pages, selectedIndexValue, {
            max: max,
            ellipsis: renderEllipsis,
            transform: transform
        }, testId);
        $[28] = max;
        $[29] = pages;
        $[30] = renderEllipsis;
        $[31] = selectedIndexValue;
        $[32] = testId;
        $[33] = transform;
        $[34] = t20;
    } else t20 = $[34];
    let t21;
    if ($[35] !== t20) {
        t21 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1l0kj.Inline), {
            space: "space.0",
            alignBlock: "baseline",
            as: "ul",
            xcss: $58ee79fc5bef7c86$var$styles.paginationMenu,
            children: t20
        });
        $[35] = t20;
        $[36] = t21;
    } else t21 = $[36];
    let t22;
    if ($[37] !== onChangeWithAnalytics || $[38] !== selectedIndexValue) {
        t22 = (event_2)=>onChangeWithAnalytics({
                event: event_2,
                selectedPageIndex: selectedIndexValue + 1
            });
        $[37] = onChangeWithAnalytics;
        $[38] = selectedIndexValue;
        $[39] = t22;
    } else t22 = $[39];
    const t23 = isDisabled || selectedIndexValue === pages.length - 1;
    let t24;
    if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
        t24 = /*#__PURE__*/ (0, $8aG6j.jsx)($58ee79fc5bef7c86$var$NavigatorIcon, {
            chevronDirection: "right"
        });
        $[40] = t24;
    } else t24 = $[40];
    const t25 = testId && `${testId}--right-navigator`;
    let t26;
    if ($[41] !== components.Next || $[42] !== nextLabel || $[43] !== t22 || $[44] !== t23 || $[45] !== t25) {
        t26 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $17f3d644edf8e222$export$2e2bcd8739ae039), {
            component: components.Next,
            onClick: t22,
            isDisabled: t23,
            iconBefore: t24,
            "aria-label": nextLabel,
            testId: t25
        }, "right-navigator");
        $[41] = components.Next;
        $[42] = nextLabel;
        $[43] = t22;
        $[44] = t23;
        $[45] = t25;
        $[46] = t26;
    } else t26 = $[46];
    let t27;
    if ($[47] !== t19 || $[48] !== t21 || $[49] !== t26) {
        t27 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
            space: "space.0",
            alignBlock: "center",
            children: [
                t19,
                t21,
                t26
            ]
        });
        $[47] = t19;
        $[48] = t21;
        $[49] = t26;
        $[50] = t27;
    } else t27 = $[50];
    let t28;
    if ($[51] !== label || $[52] !== ref || $[53] !== style || $[54] !== t27 || $[55] !== testId) {
        t28 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            testId: testId,
            style: style,
            ref: ref,
            "aria-label": label,
            as: "nav",
            children: t27
        });
        $[51] = label;
        $[52] = ref;
        $[53] = style;
        $[54] = t27;
        $[55] = testId;
        $[56] = t28;
    } else t28 = $[56];
    return t28;
} : function InnerPagination({ components: components = (0, $4a66713043ed72c4$export$3f860eba1218f8d3), defaultSelectedIndex: defaultSelectedIndex = 0, selectedIndex: selectedIndex, label: label = 'pagination', pageLabel: pageLabel = 'page', previousLabel: previousLabel = 'previous', nextLabel: nextLabel = 'next', style: style = (0, $4a66713043ed72c4$export$3f860eba1218f8d3), max: max = 7, onChange: onChange = (0, $dpsRj.default), pages: pages, getPageLabel: getPageLabel, renderEllipsis: renderEllipsis = (0, $704f330cc7acd87d$export$2e2bcd8739ae039), analyticsContext: analyticsContext, testId: testId, isDisabled: isDisabled }, ref) {
    const [selectedIndexValue, setSelectedIndexValue] = (0, $5Dlqn.default)(selectedIndex, ()=>defaultSelectedIndex || 0);
    const onChangeWithAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: (value, analyticsEvent)=>{
            const { event: event, selectedPageIndex: selectedPageIndex } = value;
            if (selectedIndex === undefined) setSelectedIndexValue(selectedPageIndex);
            if (onChange) onChange(event, pages[selectedPageIndex], analyticsEvent);
        },
        action: 'changed',
        actionSubject: 'pageNumber',
        analyticsData: analyticsContext,
        ...$58ee79fc5bef7c86$var$analyticsAttributes
    });
    const transform = (page, currPageIndex, testId_0)=>{
        const selectedPage = pages[selectedIndexValue];
        const pageIndexLabel = `${pageLabel} ${getPageLabel ? getPageLabel(page, currPageIndex) : page}`;
        const isCurrentPage = page === selectedPage;
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1l0kj.Inline), {
            as: "li",
            xcss: $58ee79fc5bef7c86$var$styles.paginationMenuItem,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $c982ffc605b50884$export$2e2bcd8739ae039), {
                component: components.Page,
                onClick: (event_0)=>onChangeWithAnalytics({
                        event: event_0,
                        selectedPageIndex: currPageIndex
                    }),
                "aria-current": isCurrentPage ? 'page' : undefined,
                "aria-label": pageIndexLabel,
                isSelected: isCurrentPage,
                isDisabled: isDisabled,
                page: page,
                testId: testId_0 && `${testId_0}--${isCurrentPage ? 'current-' : ''}page-${currPageIndex}`,
                children: getPageLabel ? getPageLabel(page, currPageIndex) : page
            })
        }, `page-${getPageLabel ? getPageLabel(page, currPageIndex) : currPageIndex}`);
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        testId: testId,
        style: style,
        ref: ref,
        "aria-label": label,
        as: "nav",
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
            space: "space.0",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $17f3d644edf8e222$export$2e2bcd8739ae039), {
                    component: components.Previous,
                    onClick: (event_1)=>onChangeWithAnalytics({
                            event: event_1,
                            selectedPageIndex: selectedIndexValue - 1
                        }),
                    isDisabled: isDisabled || selectedIndexValue === 0,
                    iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)($58ee79fc5bef7c86$var$NavigatorIcon, {
                        chevronDirection: "left"
                    }),
                    "aria-label": previousLabel,
                    testId: testId && `${testId}--left-navigator`
                }, "left-navigator"),
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1l0kj.Inline), {
                    space: "space.0",
                    alignBlock: "baseline",
                    as: "ul",
                    xcss: $58ee79fc5bef7c86$var$styles.paginationMenu,
                    children: (0, $a160bbcb7aa35a3d$export$2e2bcd8739ae039)(pages, selectedIndexValue, {
                        max: max,
                        ellipsis: renderEllipsis,
                        transform: transform
                    }, testId)
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $17f3d644edf8e222$export$2e2bcd8739ae039), {
                    component: components.Next,
                    onClick: (event_2)=>onChangeWithAnalytics({
                            event: event_2,
                            selectedPageIndex: selectedIndexValue + 1
                        }),
                    isDisabled: isDisabled || selectedIndexValue === pages.length - 1,
                    iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)($58ee79fc5bef7c86$var$NavigatorIcon, {
                        chevronDirection: "right"
                    }),
                    "aria-label": nextLabel,
                    testId: testId && `${testId}--right-navigator`
                }, "right-navigator")
            ]
        })
    }));
};
/**
 * __Pagination__
 *
 * Pagination allows you to divide large amounts of content into smaller chunks across multiple pages.
 *
 * - [Examples](https://atlassian.design/components/pagination/examples)
 * - [Code](https://atlassian.design/components/pagination/code)
 * - [Usage](https://atlassian.design/components/pagination/usage)
 */ const $58ee79fc5bef7c86$var$Pagination = /*#__PURE__*/ (0, $cozmU.memo)(/*#__PURE__*/ (0, $cozmU.forwardRef)($58ee79fc5bef7c86$var$InnerPagination));
var $58ee79fc5bef7c86$export$2e2bcd8739ae039 = $58ee79fc5bef7c86$var$Pagination;
module.exports["default"] = $58ee79fc5bef7c86$export$2e2bcd8739ae039;

});

parcelRegister("f3XUw", function(module, exports) {
$parcel$export(module.exports, "default", () => $49115eaa34d5ed39$export$2e2bcd8739ae039);

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");

function $49115eaa34d5ed39$export$2e2bcd8739ae039(WrappedComponent) {
    return class WithDimensions extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
        UNSAFE_componentWillReceiveProps(nextProps) {
            const wasRanking = this.props.isRanking;
            const willRanking = nextProps.isRanking;
            if (willRanking && !wasRanking) this.updateDimensions();
        }
        render() {
            const { refWidth: refWidth, refHeight: refHeight } = this.state;
            return /*#__PURE__*/ (0, $8aG6j.jsx)(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refWidth: refWidth,
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refHeight: refHeight,
                innerRef: this.innerRef,
                ...this.props
            });
        }
        constructor(...args){
            super(...args);
            this.ref = void 0;
            this.state = {
                refWidth: 0,
                refHeight: 0
            };
            this.innerRef = (ref)=>{
                if (ref && !this.props.isRanking) this.ref = ref;
            };
            this.updateDimensions = ()=>{
                if (!this.ref) return;
                const clientRect = this.ref.getBoundingClientRect();
                const { width: width } = clientRect;
                const { height: height } = clientRect;
                if (width !== this.state.refWidth || height !== this.state.refHeight) this.setState({
                    refWidth: width,
                    refHeight: height
                });
            };
        }
    };
}

});

parcelRegister("igC1g", function(module, exports) {
const $0c1730be0d1593e6$export$a601f1775e10043f = (isRanking, width, height)=>{
    if (!isRanking) return {};
    if (height) return {
        width: width,
        height: height
    };
    return {
        width: width
    };
};
module.exports["inlineStylesIfRanking"] = $0c1730be0d1593e6$export$a601f1775e10043f;

});

parcelRegister("b6DGi", function(module, exports) {

let $815f0920299cc140$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $815f0920299cc140$var$load("iQvHF"),
    $815f0920299cc140$var$load("2lAWD")
]).then(()=>parcelRequire('61gNL'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("jfLxM", function(module, exports) {
const $50674326dbf0d161$export$3987dc24b734dcab = (allRows, pageNumber, rowsPerPage)=>{
    if (!pageNumber || !rowsPerPage || !allRows.length) return [];
    return allRows.slice((pageNumber - 1) * rowsPerPage, pageNumber * rowsPerPage);
};
module.exports["getPageRows"] = $50674326dbf0d161$export$3987dc24b734dcab;

});

parcelRegister("iHx0I", function(module, exports) {
const $b652594310ea9151$export$9133f5a8bfe8a200 = (sortKey, head)=>{
    if (!sortKey) return;
    const headHasKey = head && head.cells.map((cell)=>cell.key).includes(sortKey);
    if (!headHasKey) try {
        throw Error(`Cell with ${sortKey} key not found in head.`);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
    }
};
module.exports["validateSortKey"] = $b652594310ea9151$export$9133f5a8bfe8a200;

});

parcelRegister("aKm7d", function(module, exports) {
const $d6beda0451d041ee$var$CSS_VAR_WIDTH = '--local-dynamic-table-width';
const $d6beda0451d041ee$export$5e6497a652ae30b5 = ({ width: width })=>typeof width !== 'undefined' ? {
        [$d6beda0451d041ee$var$CSS_VAR_WIDTH]: `${width}%`
    } : undefined;
module.exports["getTruncationStyleVars"] = $d6beda0451d041ee$export$5e6497a652ae30b5;

});


//# sourceMappingURL=RendererWithComponents.ef5eee23.js.map
